/*
 * HANRO AI Shopify JavaScript Insert
 * Generated from content.js + content.css. Edit the source files, then run:
 *   npm run build:shopify
 */
(() => {
  const config = window.GINIA_AI_CONFIG || {};
  if (config.loadStyles === false || document.getElementById("ginia-ai-stylesheet-inline")) return;
  const style = document.createElement("style");
  style.id = "ginia-ai-stylesheet-inline";
  style.textContent = "/* ── GINIA AI Sleepwear Stylist v2 – Content Script Styles ── */\n/* Namespace everything under .bell-ai to avoid style conflicts */\n/* Brand palette: Soft Black #1a1a1a, Off-White #faf7f4, Blush #e8d8cf, Satin Taupe #c8a87c */\n\n.bell-ai-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.32);\n  z-index: 2147483640;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.bell-ai-overlay.bell-ai-active {\n  opacity: 1;\n  pointer-events: all;\n}\n\n/* ── Side Panel ── */\n.bell-ai-panel {\n  position: fixed;\n  top: 0;\n  right: -640px;\n  width: 640px;\n  max-width: 92vw;\n  height: 100vh;\n  background: #ffffff;\n  z-index: 2147483645;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.16);\n  transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #222;\n  box-sizing: border-box;\n  -webkit-text-size-adjust: 100%;\n  --bell-ai-widget-clearance: 96px;\n}\n\n.bell-ai-panel *,\n.bell-ai-panel *::before,\n.bell-ai-panel *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.bell-ai-panel.bell-ai-open {\n  right: 0;\n}\n\n/* ── Panel Header ── */\n.bell-ai-header {\n  background: #1a1a1a;\n  color: #fff;\n  padding: 18px 28px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.bell-ai-header-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.bell-ai-avatar {\n  width: 42px;\n  height: 42px;\n  background: #faf7f4;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: #1a1a1a;\n}\n\n.bell-ai-title {\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  color: #fff;\n}\n\n.bell-ai-subtitle {\n  font-size: 11px;\n  opacity: 0.85;\n  margin-top: 3px;\n  color: #fff;\n  letter-spacing: 0.2px;\n}\n\n.bell-ai-status-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #4ade80;\n  margin-right: 4px;\n  vertical-align: middle;\n}\n\n.bell-ai-header-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.bell-ai-cart-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s;\n  color: #fff;\n  text-decoration: none;\n}\n\n.bell-ai-cart-icon:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.bell-ai-cart-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  background: #c8a87c;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 8px;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.bell-ai-close {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 4px 8px;\n  line-height: 1;\n  border-radius: 4px;\n  transition: background 0.15s;\n}\n\n.bell-ai-close:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.bell-ai-new-chat {\n  background: none;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  color: #fff;\n  cursor: pointer;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: background 0.15s, border-color 0.15s;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.bell-ai-new-chat:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.6);\n}\n\n.bell-ai-new-chat:active {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.bell-ai-new-chat-label {\n  line-height: 1;\n}\n\n/* ── Chat Body ── */\n.bell-ai-body {\n  flex: 1;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 24px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #faf7f4;\n}\n\n.bell-ai-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.bell-ai-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.bell-ai-body::-webkit-scrollbar-thumb {\n  background: #d8c8bc;\n  border-radius: 10px;\n}\n\n/* ── Messages ── */\n.bell-ai-msg {\n  max-width: 85%;\n  animation: bellAiFadeUp 0.35s ease both;\n}\n\n/* Messages that include a product grid should stretch to full width — the\n   3-column grid needs the room, and the bubble itself wraps the whole thing. */\n.bell-ai-msg-bot:has(.bell-ai-products-grid),\n.bell-ai-msg-bot:has(.bell-ai-fabric-guide),\n.bell-ai-msg-bot:has(.bell-ai-category-section) {\n  max-width: 100%;\n}\n\n@keyframes bellAiFadeUp {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.bell-ai-msg-bot { align-self: flex-start; }\n.bell-ai-msg-user { align-self: flex-end; }\n\n.bell-ai-bubble {\n  padding: 14px 18px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.6;\n  word-wrap: break-word;\n}\n\n.bell-ai-msg-bot .bell-ai-bubble {\n  background: #fff;\n  color: #222;\n  border: 1px solid #ecdfd4;\n  border-bottom-left-radius: 4px;\n}\n\n.bell-ai-msg-user .bell-ai-bubble {\n  background: #1a1a1a;\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.bell-ai-msg-time {\n  font-size: 11px;\n  color: #a09083;\n  margin-top: 4px;\n  padding: 0 4px;\n}\n\n.bell-ai-msg-user .bell-ai-msg-time {\n  text-align: right;\n}\n\n/* ── 3-Column Product Grid ── */\n.bell-ai-products-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-top: 12px;\n  align-items: stretch;\n}\n\n.bell-ai-products-grid .bell-ai-product {\n  min-width: unset;\n  max-width: unset;\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Category Sections ── */\n.bell-ai-category-section {\n  margin-top: 20px;\n}\n\n.bell-ai-category-section:first-child {\n  margin-top: 10px;\n}\n\n.bell-ai-category-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #ecdfd4;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n}\n\n.bell-ai-category-icon {\n  font-size: 18px;\n  line-height: 1;\n}\n\n/* ── Product Cards ── */\n.bell-ai-product {\n  min-width: 170px;\n  max-width: 220px;\n  background: #fff;\n  border: 1px solid #ecdfd4;\n  border-radius: 12px;\n  overflow: hidden;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;\n  display: flex;\n  flex-direction: column;\n}\n\n.bell-ai-product:hover {\n  box-shadow: 0 6px 22px rgba(26, 26, 26, 0.12);\n  transform: translateY(-2px);\n  border-color: #1a1a1a;\n}\n\n.bell-ai-product-img {\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  background: #f3e9e0;\n}\n\n.bell-ai-product-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  image-rendering: auto;\n  -ms-interpolation-mode: bicubic;\n  backface-visibility: hidden;\n}\n\n.bell-ai-product > a {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  text-decoration: none;\n  color: inherit;\n}\n\n.bell-ai-product-info {\n  padding: 12px 14px 14px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.bell-ai-product-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 4px;\n  min-height: 2.6em;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  letter-spacing: 0.1px;\n}\n\n.bell-ai-product-price {\n  font-size: 14px;\n  color: #1a1a1a;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.bell-ai-product-reason {\n  margin-top: 6px;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #6a6258;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ── Add to Cart Button ── */\n.bell-ai-cart-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  padding: 0 12px;\n  background: #1a1a1a;\n  color: #fff;\n  border: none;\n  border-top: 1px solid #1a1a1a;\n  border-radius: 0;\n  font-size: 11px;\n  line-height: 1;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.bell-ai-cart-btn:hover {\n  background: #c8a87c;\n  color: #fff;\n}\n\n.bell-ai-cart-btn:active {\n  background: #000;\n}\n\n.bell-ai-cart-btn-loading,\n.bell-ai-cart-btn-loading:hover {\n  background: #555 !important;\n  color: #fff !important;\n  cursor: wait;\n}\n\n.bell-ai-cart-btn-success,\n.bell-ai-cart-btn-success:hover {\n  background: #2c6a48 !important;\n  color: #fff !important;\n  cursor: default;\n}\n\n.bell-ai-cart-btn-disabled,\n.bell-ai-cart-btn-disabled:hover {\n  background: #bbb !important;\n  color: #fff !important;\n  cursor: not-allowed;\n}\n\n.bell-ai-product {\n  position: relative;\n}\n\n/* ── Size Picker — Full-Width Row ──\n   Picker slots into the grid as its own full-width row directly under the\n   clicked product's row. Card stays fully visible above. */\n.bell-ai-size-picker {\n  grid-column: 1 / -1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 22px 20px 22px;\n  background: #faf4ee;\n  border: 1px solid #ecdfd4;\n  border-radius: 12px;\n  animation: bellAiPickerReveal 0.3s cubic-bezier(0.4, 0, 0.2, 1) both;\n  overflow: hidden;\n}\n\n/* Satin taupe rule across the top of the picker — editorial cue. */\n.bell-ai-size-picker::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 28px;\n  right: 28px;\n  height: 2px;\n  background: #c8a87c;\n  opacity: 0.5;\n}\n\n/* Arrow pointing up to the clicked product card. Left offset set per-render. */\n.bell-ai-size-picker::after {\n  content: \"\";\n  position: absolute;\n  top: -7px;\n  left: var(--bell-ai-picker-arrow-left, 50%);\n  transform: translateX(-50%) rotate(45deg);\n  width: 12px;\n  height: 12px;\n  background: #faf4ee;\n  border-top: 1px solid #ecdfd4;\n  border-left: 1px solid #ecdfd4;\n}\n\n.bell-ai-size-picker-leaving {\n  animation: bellAiPickerDismiss 0.2s cubic-bezier(0.4, 0, 0.2, 1) both;\n  pointer-events: none;\n}\n\n@keyframes bellAiPickerReveal {\n  from { opacity: 0; transform: translateY(-8px); max-height: 0; }\n  to   { opacity: 1; transform: translateY(0); max-height: 640px; }\n}\n\n@keyframes bellAiPickerDismiss {\n  from { opacity: 1; transform: translateY(0); max-height: 640px; }\n  to   { opacity: 0; transform: translateY(-6px); max-height: 0; }\n}\n\n.bell-ai-product.bell-ai-product-selected {\n  border-color: #1a1a1a;\n  box-shadow: 0 8px 24px rgba(26, 26, 26, 0.14);\n  transform: translateY(-1px);\n}\n\n.bell-ai-size-picker-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 2.8px;\n  text-transform: uppercase;\n  color: #1a1a1a;\n  text-align: center;\n}\n\n.bell-ai-size-picker-label::before,\n.bell-ai-size-picker-label::after {\n  content: \"\";\n  width: 18px;\n  height: 1px;\n  background: #c8a87c;\n  flex-shrink: 0;\n}\n\n.bell-ai-size-picker-label-error {\n  color: #8a3a3a;\n  animation: bellAiShake 0.4s ease-in-out both;\n}\n\n.bell-ai-size-picker-label-error::before,\n.bell-ai-size-picker-label-error::after {\n  background: #c88a8a;\n}\n\n@keyframes bellAiShake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-3px); }\n  75% { transform: translateX(3px); }\n}\n\n.bell-ai-size-picker-close {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  width: 22px;\n  height: 22px;\n  background: none;\n  border: none;\n  border-radius: 50%;\n  color: #8a8073;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s, color 0.2s;\n}\n\n.bell-ai-size-picker-close:hover {\n  background: rgba(26, 26, 26, 0.06);\n  color: #1a1a1a;\n}\n\n.bell-ai-size-picker-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 640px;\n}\n\n.bell-ai-size-picker-with-color .bell-ai-size-picker-sizes {\n  padding-top: 14px;\n  border-top: 1px solid #ecdfd4;\n}\n\n.bell-ai-size-picker-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  max-width: 100%;\n  width: 100%;\n  max-height: 148px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 4px 6px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(200, 168, 124, 0.5) transparent;\n}\n\n.bell-ai-size-picker-colors-row {\n  gap: 10px 14px;\n  max-height: 176px;\n}\n\n.bell-ai-size-picker-options::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.bell-ai-size-picker-options::-webkit-scrollbar-track {\n  background: transparent;\n  margin: 2px 0;\n}\n.bell-ai-size-picker-options::-webkit-scrollbar-thumb {\n  background: rgba(200, 168, 124, 0.4);\n  border-radius: 3px;\n}\n.bell-ai-size-picker-options::-webkit-scrollbar-thumb:hover {\n  background: rgba(200, 168, 124, 0.65);\n}\n\n/* Color swatch chip */\n.bell-ai-color-chip {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 4px 2px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  font-family: inherit;\n  cursor: pointer;\n  color: #1a1a1a;\n  transition: transform 0.18s cubic-bezier(0.4, 0, 0.2, 1),\n              border-color 0.18s,\n              box-shadow 0.18s;\n}\n\n.bell-ai-color-chip-swatch {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 1px rgba(26, 26, 26, 0.12),\n              0 1px 2px rgba(26, 26, 26, 0.08);\n  transition: box-shadow 0.2s, transform 0.18s;\n  flex-shrink: 0;\n}\n\n.bell-ai-color-chip-label {\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #6a6258;\n  max-width: 88px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: color 0.2s;\n}\n\n.bell-ai-color-chip:hover .bell-ai-color-chip-swatch {\n  box-shadow: inset 0 0 0 1px rgba(26, 26, 26, 0.18),\n              0 4px 10px rgba(26, 26, 26, 0.16);\n  transform: translateY(-1px);\n}\n\n.bell-ai-color-chip:hover .bell-ai-color-chip-label {\n  color: #1a1a1a;\n}\n\n.bell-ai-color-chip-active .bell-ai-color-chip-swatch,\n.bell-ai-color-chip-active:hover .bell-ai-color-chip-swatch {\n  box-shadow: 0 0 0 1.5px #1a1a1a,\n              inset 0 0 0 2px #faf4ee,\n              inset 0 0 0 3px rgba(26, 26, 26, 0.12);\n  transform: translateY(-1px);\n}\n\n.bell-ai-color-chip-active .bell-ai-color-chip-label {\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.bell-ai-size-picker-loading {\n  display: inline-block;\n  padding: 10px 16px;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 2.2px;\n  text-transform: uppercase;\n  color: #8a8073;\n  animation: bellAiLoadPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes bellAiLoadPulse {\n  0%, 100% { opacity: 0.5; }\n  50%      { opacity: 1; }\n}\n\n.bell-ai-color-chip-unavailable,\n.bell-ai-color-chip-unavailable:hover {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.bell-ai-color-chip-unavailable .bell-ai-color-chip-swatch {\n  background-image: linear-gradient(\n    135deg,\n    transparent 44%, rgba(26, 26, 26, 0.55) 46%,\n    rgba(26, 26, 26, 0.55) 54%, transparent 56%\n  ) !important;\n}\n\n/* Size chip */\n.bell-ai-size-chip {\n  min-width: 46px;\n  height: 38px;\n  padding: 0 14px;\n  background: transparent;\n  color: #1a1a1a;\n  border: 1px solid #1a1a1a;\n  border-radius: 2px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  font-family: inherit;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n              color 0.28s,\n              letter-spacing 0.28s,\n              transform 0.12s;\n}\n\n.bell-ai-size-chip:hover {\n  background: #1a1a1a;\n  color: #faf7f4;\n  letter-spacing: 1.9px;\n}\n\n.bell-ai-size-chip:active {\n  transform: scale(0.96);\n}\n\n.bell-ai-size-chip-loading,\n.bell-ai-size-chip-loading:hover {\n  background: #1a1a1a;\n  color: #faf7f4;\n  letter-spacing: 1.9px;\n  cursor: wait;\n}\n\n.bell-ai-size-chip-loading::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 2px;\n  width: 100%;\n  background: #c8a87c;\n  transform-origin: left center;\n  animation: bellAiChipLoad 0.9s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n\n@keyframes bellAiChipLoad {\n  0%   { transform: scaleX(0); opacity: 1; }\n  60%  { transform: scaleX(1); opacity: 1; }\n  100% { transform: scaleX(1); opacity: 0; }\n}\n\n.bell-ai-size-chip-unavailable,\n.bell-ai-size-chip-unavailable:hover {\n  background: transparent;\n  color: #c5bcb0;\n  border: 1px dashed #d8d1c6;\n  text-decoration: line-through;\n  text-decoration-thickness: 1px;\n  letter-spacing: 1.4px;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* ── Upsell Section ── */\n.bell-ai-upsell-section {\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1.5px solid #ecdfd4;\n}\n\n.bell-ai-upsell-header {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 12px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.bell-ai-upsell-icon {\n  font-size: 15px;\n}\n\n.bell-ai-upsell-card {\n  border-color: #d8c8bc;\n}\n\n.bell-ai-upsell-card .bell-ai-product-img {\n  height: 160px;\n}\n\n.bell-ai-upsell-why {\n  font-size: 11px;\n  color: #1a1a1a;\n  font-weight: 600;\n  margin-top: 4px;\n  line-height: 1.35;\n}\n\n.bell-ai-upsell-benefit {\n  font-size: 10.5px;\n  color: #6a6258;\n  margin-top: 3px;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.bell-ai-upsell-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin-top: 5px;\n}\n\n.bell-ai-upsell-tag {\n  font-size: 9px;\n  font-weight: 600;\n  color: #1a1a1a;\n  background: rgba(200, 168, 124, 0.12);\n  border: 1px solid rgba(200, 168, 124, 0.28);\n  border-radius: 4px;\n  padding: 1.5px 5px;\n  letter-spacing: 0.2px;\n  white-space: nowrap;\n}\n\n.bell-ai-upsell-card .bell-ai-cart-btn {\n  background: #c8a87c;\n  border-top-color: #c8a87c;\n  font-size: 11px;\n  letter-spacing: 1px;\n}\n\n.bell-ai-upsell-card .bell-ai-cart-btn:hover {\n  background: #1a1a1a;\n  border-top-color: #1a1a1a;\n}\n\n/* ── Quick Actions ── */\n.bell-ai-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.bell-ai-action-btn {\n  padding: 7px 14px;\n  border: 1px solid #d8c8bc;\n  background: #fff;\n  border-radius: 20px;\n  font-size: 12px;\n  color: #1a1a1a;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.15s;\n  font-family: inherit;\n  line-height: 1.4;\n}\n\n.bell-ai-action-btn:hover {\n  background: #1a1a1a;\n  color: #fff;\n  border-color: #1a1a1a;\n}\n\n/* ── Suggestion Chips ── */\n.bell-ai-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.bell-ai-chip {\n  padding: 9px 16px;\n  background: #fff;\n  border: 1px solid #d8c8bc;\n  border-radius: 22px;\n  font-size: 13px;\n  color: #555;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: inherit;\n  line-height: 1.4;\n}\n\n.bell-ai-chip:hover {\n  border-color: #1a1a1a;\n  color: #1a1a1a;\n  background: #e8d8cf;\n}\n\n/* ── Typing Indicator ── */\n.bell-ai-typing {\n  display: none;\n  align-items: center;\n  gap: 5px;\n  padding: 14px 18px;\n  background: #fff;\n  border: 1px solid #ecdfd4;\n  border-radius: 18px;\n  border-bottom-left-radius: 4px;\n  width: fit-content;\n}\n\n.bell-ai-typing.bell-ai-visible {\n  display: flex;\n}\n\n.bell-ai-typing-dot {\n  width: 7px;\n  height: 7px;\n  background: #c8a87c;\n  border-radius: 50%;\n  animation: bellAiBounce 0.6s infinite alternate;\n}\n\n.bell-ai-typing-dot:nth-child(2) { animation-delay: 0.15s; }\n.bell-ai-typing-dot:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes bellAiBounce {\n  to { transform: translateY(-5px); opacity: 0.4; }\n}\n\n/* ── Input Area ── */\n.bell-ai-input-area {\n  padding: 16px calc(24px + var(--bell-ai-widget-clearance)) 16px 24px;\n  border-top: 1px solid #ecdfd4;\n  display: flex;\n  gap: 10px;\n  background: #fff;\n  flex-shrink: 0;\n  align-items: center;\n}\n\n.bell-ai-input {\n  flex: 1;\n  border: 1.5px solid #d8c8bc;\n  border-radius: 26px;\n  padding: 12px 20px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  font-family: inherit;\n  color: #222;\n  background: #fff;\n}\n\n.bell-ai-input:focus {\n  border-color: #1a1a1a;\n  box-shadow: 0 0 0 3px rgba(200, 168, 124, 0.12);\n}\n\n.bell-ai-input::placeholder {\n  color: #aaa;\n}\n\n.bell-ai-send {\n  width: 46px;\n  height: 46px;\n  min-width: 46px;\n  border-radius: 50%;\n  background: #1a1a1a;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s, transform 0.1s;\n  flex-shrink: 0;\n}\n\n.bell-ai-send:hover { background: #333333; }\n.bell-ai-send:active { transform: scale(0.95); }\n.bell-ai-send svg { width: 20px; height: 20px; }\n\n/* ── Analysis Steps ── */\n.bell-ai-analysis {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.bell-ai-analysis-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #555;\n}\n\n.bell-ai-analysis-step svg { width: 16px; height: 16px; flex-shrink: 0; }\n.bell-ai-analysis-step.bell-ai-done svg { color: #16a34a; }\n.bell-ai-analysis-step.bell-ai-active svg { color: #1a1a1a; animation: bellAiSpin 1s linear infinite; }\n.bell-ai-analysis-step.bell-ai-pending { color: #bbb; }\n.bell-ai-analysis-step.bell-ai-pending svg { color: #ccc; }\n\n@keyframes bellAiSpin { to { transform: rotate(360deg); } }\n\n/* ── Advisor Intro ── */\n.bell-ai-advisor-intro {\n  font-size: 14px;\n  font-style: italic;\n  color: #1a1a1a;\n  line-height: 1.5;\n  margin-bottom: 12px;\n  padding: 4px 0;\n}\n\n/* ── Context Banner ── */\n.bell-ai-context {\n  background: #e8d8cf;\n  border: 1px solid #d8c8bc;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 12px;\n  color: #3d2e24;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bell-ai-context-icon {\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n/* ── Concern / Fit Cards ── */\n.bell-ai-health-card {\n  background: linear-gradient(135deg, #e8d8cf 0%, #f5ebe3 100%);\n  border: 1.5px solid #d8c8bc;\n  border-radius: 14px;\n  padding: 14px 16px;\n  margin-bottom: 8px;\n}\n\n.bell-ai-health-card-header {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 6px;\n}\n\n.bell-ai-health-card-desc {\n  font-size: 13px;\n  color: #555;\n  line-height: 1.5;\n}\n\n/* ── Recommendation List ── */\n.bell-ai-rec-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.bell-ai-rec-item {\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid #ecdfd4;\n  border-radius: 10px;\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* ── Fabric Tip ── */\n.bell-ai-fabric-tip {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background: #fffbf0;\n  border: 1px solid #e8dcc0;\n  border-radius: 10px;\n  font-size: 13px;\n  color: #7a6c00;\n}\n\n/* ── Fabric Guide ── */\n.bell-ai-fabric-guide {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.bell-ai-fabric-card {\n  background: #fff;\n  border: 1.5px solid #ecdfd4;\n  border-radius: 12px;\n  padding: 12px 14px;\n  transition: border-color 0.2s;\n}\n\n.bell-ai-fabric-card:hover {\n  border-color: #1a1a1a;\n}\n\n.bell-ai-fabric-header {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n}\n\n.bell-ai-fabric-note {\n  font-size: 13px;\n  color: #555;\n  margin-bottom: 8px;\n  line-height: 1.4;\n}\n\n.bell-ai-fabric-tags {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.bell-ai-tag {\n  padding: 2px 10px;\n  background: #e8d8cf;\n  border: 1px solid #d8c8bc;\n  border-radius: 12px;\n  font-size: 11px;\n  color: #1a1a1a;\n  font-weight: 500;\n}\n\n/* ── Footer ── */\n.bell-ai-footer {\n  padding: 10px 24px;\n  text-align: center;\n  font-size: 11px;\n  color: #a09083;\n  background: #fff;\n  border-top: 1px solid #f3e9e0;\n  flex-shrink: 0;\n  letter-spacing: 0.3px;\n}\n\n/* ── \"Ask the stylist\" Ribbon ──\n   Anchored flush to the right edge of the viewport. Slides slightly left on\n   hover for a tactile pull cue. Satin taupe rail + pulsing glow. */\n.bell-ai-trigger {\n  position: fixed;\n  top: 150px;\n  right: 0;\n  z-index: 2147483639;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 13px 20px 13px 22px;\n  background: #1a1a1a;\n  color: #faf7f4;\n  border: none;\n  border-right: none;\n  border-radius: 10px 0 0 10px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  box-shadow: -3px 6px 20px rgba(26, 26, 26, 0.22);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n              box-shadow 0.25s,\n              background 0.2s;\n}\n\n.bell-ai-trigger:hover {\n  transform: translateX(-4px);\n  background: #2a2a2a;\n  box-shadow: -6px 8px 26px rgba(26, 26, 26, 0.3);\n}\n\n.bell-ai-trigger:active {\n  transform: translateX(-2px);\n}\n\n.bell-ai-trigger:focus-visible {\n  outline: 2px solid #c8a87c;\n  outline-offset: 2px;\n}\n\n.bell-ai-trigger-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  color: #c8a87c;\n  flex-shrink: 0;\n}\n\n.bell-ai-trigger-icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.bell-ai-trigger-label {\n  line-height: 1;\n}\n\n.bell-ai-trigger-badge {\n  position: absolute;\n  top: -7px;\n  left: -7px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  background: #c8a87c;\n  color: #fff;\n  border: 2px solid #fff;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n  line-height: 16px;\n  text-align: center;\n  font-family: inherit;\n}\n\n.bell-ai-trigger::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 10px;\n  bottom: 10px;\n  width: 3px;\n  background: #c8a87c;\n  border-radius: 0 2px 2px 0;\n}\n\n.bell-ai-trigger::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 rgba(200, 168, 124, 0);\n  animation: bellAiRibbonPulse 2.6s ease-out infinite;\n  pointer-events: none;\n}\n\n@keyframes bellAiRibbonPulse {\n  0%   { box-shadow: 0 0 0 0 rgba(200, 168, 124, 0.5); }\n  70%  { box-shadow: -14px 0 0 6px rgba(200, 168, 124, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(200, 168, 124, 0); }\n}\n\n/* ── Responsive ── */\n@media (max-width: 720px) {\n  .bell-ai-panel {\n    width: 100vw;\n    right: -100vw;\n    max-width: none;\n    height: 100vh;\n    height: 100dvh;\n    max-height: 100dvh;\n    --bell-ai-widget-clearance: 74px;\n  }\n  .bell-ai-panel.bell-ai-open {\n    right: 0;\n  }\n  .bell-ai-body {\n    padding: 18px;\n    gap: 14px;\n  }\n  .bell-ai-products-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n  .bell-ai-header {\n    padding: 14px 16px;\n  }\n  .bell-ai-avatar {\n    width: 36px;\n    height: 36px;\n    font-size: 18px;\n  }\n  .bell-ai-title {\n    font-size: 15px;\n  }\n  .bell-ai-subtitle {\n    font-size: 10px;\n  }\n  .bell-ai-new-chat {\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border-radius: 50%;\n  }\n  .bell-ai-new-chat-label {\n    display: none;\n  }\n  .bell-ai-cart-icon,\n  .bell-ai-close {\n    width: 34px;\n    height: 34px;\n    min-width: 34px;\n  }\n  .bell-ai-close {\n    padding: 0;\n  }\n  .bell-ai-msg {\n    max-width: 92%;\n  }\n  .bell-ai-bubble {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n  .bell-ai-product-img {\n    height: 150px;\n  }\n  .bell-ai-product-info {\n    padding: 10px 10px 12px;\n  }\n  .bell-ai-product-name {\n    font-size: 12px;\n  }\n  .bell-ai-product-price {\n    font-size: 13px;\n  }\n  .bell-ai-product-reason {\n    display: none;\n  }\n  .bell-ai-cart-btn {\n    height: 42px;\n    padding: 0 8px;\n    font-size: 10px;\n    letter-spacing: 0.8px;\n  }\n  .bell-ai-size-picker {\n    padding: 20px 12px 18px;\n  }\n  .bell-ai-size-picker-close {\n    width: 34px;\n    height: 34px;\n    top: 4px;\n    right: 4px;\n  }\n  .bell-ai-size-chip {\n    min-width: 48px;\n    height: 42px;\n  }\n  .bell-ai-input-area {\n    padding: 12px calc(14px + var(--bell-ai-widget-clearance)) calc(12px + env(safe-area-inset-bottom, 0px)) 14px;\n    gap: 8px;\n  }\n  .bell-ai-input {\n    min-width: 0;\n    padding: 12px 16px;\n  }\n  .bell-ai-send {\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n  }\n  .bell-ai-trigger {\n    top: 108px;\n    padding: 11px 16px 11px 18px;\n    font-size: 11px;\n    letter-spacing: 1.2px;\n  }\n  .bell-ai-trigger-icon,\n  .bell-ai-trigger-icon svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n@media (min-width: 721px) and (max-width: 760px) {\n  .bell-ai-panel {\n    --bell-ai-widget-clearance: 96px;\n  }\n}\n\n@media (max-width: 480px) {\n  .bell-ai-products-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n  .bell-ai-body {\n    padding: 14px;\n  }\n  .bell-ai-suggestions {\n    gap: 8px;\n  }\n  .bell-ai-chip {\n    padding: 9px 12px;\n    font-size: 12px;\n  }\n  .bell-ai-product-img {\n    height: 136px;\n  }\n}\n";
  document.head.appendChild(style);
})();

/**
 * HANRO Australia - AI Product Advisor v1 — Shopify Insert
 * Gemini-powered conversational premium underwear, sleepwear and loungewear advisor
 * Guides customers through: Category → Fabric → Occasion → Size → Product Match
 * Tuned for the exported HANRO Australia product range
 */

(function () {
  "use strict";

  if (document.getElementById("ginia-ai-root")) return;
  if (window.location.pathname === "/password") return;

  // ── Constants ──
  const GINIA_AI_CONFIG = window.GINIA_AI_CONFIG || {};
  const SHOP_ID = GINIA_AI_CONFIG.shopId || GINIA_AI_CONFIG.shop || "hanro";

  function deriveBackendSiblingEndpoint(endpoint, siblingName) {
    const value = String(endpoint || "");
    const match = value.match(/^(.*\/(?:api|apps\/ginia-ai|apps\/ai-stylist))\/(?:gemini|chat)\/?(?:\?.*)?$/);
    if (match) return `${match[1]}/${siblingName}`;
    const vercelChatMatch = value.match(/^(https?:\/\/[^/?#]+)\/chat\/?(?:\?.*)?$/);
    return vercelChatMatch ? `${vercelChatMatch[1]}/api/${siblingName}` : "";
  }

  const AI_BACKEND_ENDPOINT = GINIA_AI_CONFIG.backendEndpoint || "https://shop-backend-pied.vercel.app/chat";
  const HAS_RECOMMEND_ENDPOINT_CONFIG =
    Object.prototype.hasOwnProperty.call(GINIA_AI_CONFIG, "recommendEndpoint");
  const AI_RECOMMEND_ENDPOINT = HAS_RECOMMEND_ENDPOINT_CONFIG
    ? GINIA_AI_CONFIG.recommendEndpoint
    : deriveBackendSiblingEndpoint(AI_BACKEND_ENDPOINT, "recommend");
  const DEFAULT_SITE_BASE = "https://hanro.com.au";
  const SITE_BASE = (GINIA_AI_CONFIG.siteBase || window.location.origin || DEFAULT_SITE_BASE).replace(/\/$/, "");
  const AUTO_OPEN = GINIA_AI_CONFIG.autoOpen !== false;
  const ANALYTICS_ENABLED = GINIA_AI_CONFIG.analyticsEnabled !== false;
  const HAS_ANALYTICS_ENDPOINT_CONFIG =
    Object.prototype.hasOwnProperty.call(GINIA_AI_CONFIG, "analyticsEndpoint");
  const ANALYTICS_ENDPOINT = HAS_ANALYTICS_ENDPOINT_CONFIG
    ? GINIA_AI_CONFIG.analyticsEndpoint
    : deriveBackendSiblingEndpoint(AI_BACKEND_ENDPOINT, "analytics");
  const ANALYTICS_EVENT_PREFIX = GINIA_AI_CONFIG.analyticsEventPrefix || "hanro_ai";
  const ANALYTICS_CAPTURE_MESSAGE_TEXT = GINIA_AI_CONFIG.analyticsCaptureMessageText === true;
  const ANALYTICS_DEBUG = GINIA_AI_CONFIG.analyticsDebug === true;
  const STORAGE_SCOPE = `giniaAi:${SHOP_ID}:`;
  const SESSION_VERSION = 2;
  const SESSION_TTL_MS = 30 * 60 * 1000;
  const DISMISSED_TTL_MS = 24 * 60 * 60 * 1000;
  const LEGACY_VISITOR_KEY = "giniaAiVisitorId";
  const VISITOR_KEY = scopedStorageKey("visitorId");
  const ANALYTICS_SESSION_KEY = scopedStorageKey("analyticsSession");
  const CONVERSATION_SESSION_KEY = scopedStorageKey("conversationSession");
  const CART_ATTRIBUTED_KEY = scopedStorageKey("cartAttributedFor");

  function scopedStorageKey(key) {
    return `${STORAGE_SCOPE}${key}`;
  }

  function makeId(prefix) {
    const random = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    return `${prefix}_${random}`;
  }

  function getStorageValue(storage, key) {
    try { return storage.getItem(key); } catch (e) { return ""; }
  }

  function setStorageValue(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }

  const visitorId = (() => {
    const existing = getStorageValue(localStorage, VISITOR_KEY);
    if (existing) return existing;
    const legacy = getStorageValue(localStorage, LEGACY_VISITOR_KEY);
    if (legacy) {
      setStorageValue(localStorage, VISITOR_KEY, legacy);
      return legacy;
    }
    const next = makeId("v");
    setStorageValue(localStorage, VISITOR_KEY, next);
    return next;
  })();

  function createConversationSession(reason) {
    const now = Date.now();
    return {
      id: makeId("c"),
      version: SESSION_VERSION,
      reason: reason || "new",
      startedAt: now,
      lastInteractionAt: now
    };
  }

  function loadConversationSessionMetadata() {
    try {
      const raw = getStorageValue(localStorage, CONVERSATION_SESSION_KEY);
      const session = raw ? JSON.parse(raw) : null;
      const lastInteractionAt = Number(session?.lastInteractionAt || session?.startedAt || 0);
      if (!session?.id || session.version !== SESSION_VERSION || Date.now() - lastInteractionAt > SESSION_TTL_MS) {
        return createConversationSession("expired_or_missing");
      }
      return session;
    } catch (e) {
      return createConversationSession("invalid");
    }
  }

  let conversationSession = loadConversationSessionMetadata();
  let pendingConversationUiResetReason = "";

  function persistConversationSessionMetadata() {
    setStorageValue(localStorage, CONVERSATION_SESSION_KEY, JSON.stringify(conversationSession));
  }

  function rotateConversationSession(reason) {
    conversationSession = createConversationSession(reason);
    persistConversationSessionMetadata();
    return conversationSession;
  }

  function markConversationActivity() {
    const lastInteractionAt = Number(conversationSession.lastInteractionAt || conversationSession.startedAt || 0);
    if (lastInteractionAt && Date.now() - lastInteractionAt > SESSION_TTL_MS) {
      rotateConversationSession("inactive_timeout");
      resetConversationContext();
      resetConversationHistory();
      clearSavedSession();
      resetAnalyticsCountersForConversation();
      pendingConversationUiResetReason = "inactive_timeout";
    }
    conversationSession.lastInteractionAt = Date.now();
    persistConversationSessionMetadata();
  }

  persistConversationSessionMetadata();

  const analyticsSession = (() => {
    let session = null;
    try {
      const raw = getStorageValue(sessionStorage, ANALYTICS_SESSION_KEY);
      session = raw ? JSON.parse(raw) : null;
    } catch (e) {}
    if (!session || !session.id) {
      session = { id: makeId("s"), startedAt: new Date().toISOString() };
      setStorageValue(sessionStorage, ANALYTICS_SESSION_KEY, JSON.stringify(session));
    }
    return session;
  })();

  const analyticsState = {
    pageStartedAt: Date.now(),
    panelOpenedAt: 0,
    activePanelMs: 0,
    messagesSent: 0,
    productsShown: 0,
    addToCartClicks: 0,
    addToCartSuccesses: 0,
    lastEventAt: ""
  };

  function resetAnalyticsCountersForConversation() {
    analyticsState.pageStartedAt = Date.now();
    analyticsState.activePanelMs = 0;
    analyticsState.panelOpenedAt = document.getElementById('bellAiPanel')?.classList.contains('bell-ai-open') ? Date.now() : 0;
    analyticsState.messagesSent = 0;
    analyticsState.productsShown = 0;
    analyticsState.addToCartClicks = 0;
    analyticsState.addToCartSuccesses = 0;
    analyticsState.lastEventAt = "";
  }

  function compactAnalyticsPayload(payload) {
    const out = {};
    Object.entries(payload || {}).forEach(([key, value]) => {
      if (value === undefined || typeof value === "function") return;
      if (value instanceof Error) {
        out[key] = value.message;
      } else if (Array.isArray(value)) {
        out[key] = value.slice(0, 20).map(item => (
          item && typeof item === "object" ? compactAnalyticsPayload(item) : item
        ));
      } else if (value && typeof value === "object") {
        out[key] = compactAnalyticsPayload(value);
      } else {
        out[key] = value;
      }
    });
    return out;
  }

  function getPageAnalyticsContext() {
    return {
      url: window.location.href,
      path: window.location.pathname,
      title: document.title || "",
      referrer: document.referrer || "",
      userAgent: navigator.userAgent || "",
      locale: navigator.language || "",
      viewport: `${window.innerWidth || 0}x${window.innerHeight || 0}`
    };
  }

  function publishAnalyticsEvent(name, payload = {}, options = {}) {
    if (!ANALYTICS_ENABLED) return;
    const eventName = `${ANALYTICS_EVENT_PREFIX}_${name}`;
    const now = new Date().toISOString();
    analyticsState.lastEventAt = now;

    const event = compactAnalyticsPayload({
      event: eventName,
      eventName: name,
      sentAt: now,
      sessionId: analyticsSession.id,
      conversationSessionId: conversationSession.id,
      conversationStartedAt: new Date(conversationSession.startedAt).toISOString(),
      conversationLastInteractionAt: new Date(conversationSession.lastInteractionAt).toISOString(),
      visitorId,
      shopId: SHOP_ID,
      shopDomain: window.Shopify?.shop || window.location.hostname,
      siteBase: SITE_BASE,
      page: getPageAnalyticsContext(),
      metrics: {
        pageSessionMs: Date.now() - analyticsState.pageStartedAt,
        activePanelMs: getActivePanelMs(),
        conversationSessionMs: Date.now() - Number(conversationSession.startedAt || Date.now()),
        conversationIdleMs: Date.now() - Number(conversationSession.lastInteractionAt || Date.now()),
        messagesSent: analyticsState.messagesSent,
        productsShown: analyticsState.productsShown,
        addToCartClicks: analyticsState.addToCartClicks,
        addToCartSuccesses: analyticsState.addToCartSuccesses
      },
      ...payload
    });

    if (ANALYTICS_DEBUG) console.log("[HANRO AI analytics]", event);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...event });
    } catch (e) {}

    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", eventName, event);
      }
    } catch (e) {}

    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(eventName, event);
      }
    } catch (e) {}

    try {
      if (typeof GINIA_AI_CONFIG.analyticsCallback === "function") {
        GINIA_AI_CONFIG.analyticsCallback(eventName, event);
      }
    } catch (e) {}

    if (!ANALYTICS_ENDPOINT) return;

    try {
      const body = JSON.stringify(event);
      if (options.beacon && navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(ANALYTICS_ENDPOINT, blob)) return;
      }
      fetch(ANALYTICS_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body,
        credentials: GINIA_AI_CONFIG.analyticsFetchCredentials || "omit",
        keepalive: options.beacon === true
      }).catch(() => {});
    } catch (e) {}
  }

  function getActivePanelMs() {
    const currentOpenMs = analyticsState.panelOpenedAt ? Date.now() - analyticsState.panelOpenedAt : 0;
    return analyticsState.activePanelMs + currentOpenMs;
  }

  function summarizeMessageForAnalytics(text) {
    const value = String(text || "");
    const summary = {
      messageLength: value.length,
      wordCount: value.trim() ? value.trim().split(/\s+/).length : 0
    };
    if (ANALYTICS_CAPTURE_MESSAGE_TEXT) summary.messageText = value.slice(0, 1000);
    return summary;
  }

  function getProductAnalyticsData(handle, productName, extra = {}) {
    return compactAnalyticsPayload({
      productHandle: handle || "",
      productName: productName || "",
      ...extra
    });
  }

  function markCartAttributed(reason) {
    if (!ANALYTICS_ENABLED) return;
    const key = `${analyticsSession.id}:${conversationSession.id}:${reason || "engaged"}`;
    if (getStorageValue(sessionStorage, CART_ATTRIBUTED_KEY) === key) return;
    setStorageValue(sessionStorage, CART_ATTRIBUTED_KEY, key);

    const params = new URLSearchParams();
    params.append("attributes[hanro_ai_session_id]", analyticsSession.id);
    params.append("attributes[hanro_ai_conversation_session_id]", conversationSession.id);
    params.append("attributes[hanro_ai_visitor_id]", visitorId);
    params.append("attributes[hanro_ai_engaged]", "true");
    params.append("attributes[hanro_ai_attributed_reason]", reason || "engaged");
    params.append("attributes[hanro_ai_last_event_at]", new Date().toISOString());

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: params.toString(),
      credentials: "same-origin",
      keepalive: true
    }).catch(() => {});
  }

  function sendRuntimeMessage(message) {
    try {
      if (typeof chrome !== "undefined" && chrome.runtime?.sendMessage) {
        chrome.runtime.sendMessage(message);
      }
    } catch (e) {}
  }

  function addRuntimeMessageListener(listener) {
    try {
      if (typeof chrome !== "undefined" && chrome.runtime?.onMessage?.addListener) {
        chrome.runtime.onMessage.addListener(listener);
      }
    } catch (e) {}
  }

  function inferStylesheetUrl() {
    const currentScript = document.currentScript;
    const scriptSrc = currentScript && currentScript.src;
    if (!scriptSrc) return "";
    return scriptSrc.replace(/content\.js(?:\?.*)?$/, "content.css");
  }

  function loadStylesheet() {
    if (GINIA_AI_CONFIG.loadStyles === false) return;
    if (document.getElementById("ginia-ai-stylesheet")) return;

    const stylesheetUrl = GINIA_AI_CONFIG.stylesheetUrl || inferStylesheetUrl();
    if (!stylesheetUrl || stylesheetUrl === document.currentScript?.src) return;

    const link = document.createElement("link");
    link.id = "ginia-ai-stylesheet";
    link.rel = "stylesheet";
    link.href = stylesheetUrl;
    document.head.appendChild(link);
  }

  loadStylesheet();

  // ── HANRO Product Knowledge Base ──
  const PRODUCT_CATALOG = {
    categories: {
      bra: {
        label: "Bras",
        icon: "🩱",
        description: "Underwire, soft cup and padded bras — Moments, Cotton Lace and Satin Deluxe",
        products: [
          { name: "Moments Underwire Bra", url: "/products/black-moments-underwire-bra", price: "$159.95" },
          { name: "Cotton Lace Soft Cup Bra", url: "/products/cotton-lace-soft-cup-bra-1", price: "$129.95" },
          { name: "Satin Deluxe Padded Soft Bra", url: "/products/black-satin-deluxe-padded-bra-soft", price: "$184.95" }
        ]
      },
      briefs: {
        label: "Briefs",
        icon: "🩲",
        description: "Cotton Seamless, Cotton Sensation, Moments and lace briefs",
        products: [
          { name: "Moments Midi Briefs", url: "/products/black-moments-midi-brief", price: "$104.95" },
          { name: "Cotton Seamless Mini Briefs", url: "/products/beige-cotton-seamless-mini-briefs", price: "$74.95" },
          { name: "Cotton Lace Thong", url: "/products/black-cotton-lace-thong", price: "$74.95" },
          { name: "Satin Deluxe Boyleg", url: "/products/natural-satin-deluxe-boyleg", price: "$104.95" }
        ]
      },
      nightdress: {
        label: "Nightdresses",
        icon: "🌙",
        description: "Long, mid and short-sleeve nightdresses in Cotton Deluxe, Moments and lace",
        products: [
          { name: "Cotton Deluxe Long Sleeve Nightdress 90cm", url: "/products/cotton-deluxe-l-slv-nightdress-90cm-1", price: "$314.95" },
          { name: "Moments 3/4 Sleeve Nightdress 100cm", url: "/products/copy-of-moments-nw-3-4-slv-nightdress-100cm", price: "$234.95" },
          { name: "Anilla Long Sleeve Nightdress 100cm", url: "/products/anilla-l-slv-nightdress-100cm", price: "$269.95" }
        ]
      },
      pyjama: {
        label: "Pyjamas",
        icon: "✨",
        description: "Matching pyjama sets and separates — long and short, women's and men's",
        products: []
      },
      robe: {
        label: "Robes",
        icon: "🧥",
        description: "Bath and dressing robes — Night & Day, Cotton Deluxe and Pure Silk",
        products: [
          { name: "Night & Day Robe", url: "/products/night-day-robe-1", price: "$369.95" }
        ]
      },
      cami: {
        label: "Camis & Tops",
        icon: "👚",
        description: "Spaghetti tops, camisoles and shirts — Pure Silk, Ultralight and Cotton Sensation",
        products: [
          { name: "Pure Silk Spaghetti Top", url: "/products/pure-silk-spaghetti-top", price: "$274.95" },
          { name: "Ultralight Spaghetti Top", url: "/products/ultralight-spaghetti-top", price: "$129.95" }
        ]
      },
      shirt: {
        label: "Shirts",
        icon: "👔",
        description: "Long and short-sleeve shirts in Pure Silk and natural fibres",
        products: [
          { name: "Pure Silk Long Sleeve Shirt", url: "/products/pure-silk-l-slv-shirt", price: "$494.95" }
        ]
      },
      shorts: {
        label: "Shorts",
        icon: "🩳",
        description: "Lounge shorts and pyjama shorts — Night & Day and Cotton",
        products: [
          { name: "Night & Day Iris Short Pants", url: "/products/black-iris-night-day-short-pants", price: "$159.95" }
        ]
      },
      pants: {
        label: "Pants & Leggings",
        icon: "👖",
        description: "Lounge pants, leggings and pyjama pants — Woolen Silk and Cotton",
        products: [
          { name: "Woolen Silk Leggings", url: "/products/woolen-silk-leggings-1", price: "$249.95" }
        ]
      },
      "mens-underwear": {
        label: "Men's Underwear",
        icon: "👨",
        description: "Men's briefs, boxers and boxer briefs — Cotton Superior, Cotton Sensation and Cotton Essentials",
        products: [
          { name: "Cotton Superior Long Leg Boxer Brief", url: "/products/black-cotton-superior-long-leg-boxer-brief", price: "$114.95" },
          { name: "Cotton Sensation Briefs", url: "/products/black-cotton-sensation-briefs", price: "$89.95" }
        ]
      },
      basics: {
        label: "Basics",
        icon: "⭐",
        description: "Everyday underwear, tops and pants in Hanro's signature cotton lines",
        products: []
      },
      leisurewear: {
        label: "Leisurewear",
        icon: "🏠",
        description: "Loungewear and leisure separates for home — robes, lounge pants, soft tops",
        products: []
      },
      accessories: {
        label: "Accessories",
        icon: "🎀",
        description: "Bags and finishing pieces from the Hanro accessoires line",
        products: [
          { name: "Accessoires Bag", url: "/products/accessoires-bag", price: "$189.95" }
        ]
      }
    },

    // Fabric profiles (primary material families)
    fabrics: {
      "pure-silk": {
        label: "Pure Silk",
        icon: "💫",
        benefits: ["Temperature-regulating", "Soft, fluid drape", "Refined hand-feel"],
        bestFor: ["Hot sleepers", "Travel", "Premium gifts"]
      },
      "woolen-silk": {
        label: "Woolen Silk",
        icon: "🧶",
        benefits: ["Wool-silk blend warmth", "Skin-soft against the body", "Quietly luxurious"],
        bestFor: ["Cold sleepers", "Winter layering", "Sensitive skin"]
      },
      "satin-deluxe": {
        label: "Satin Deluxe",
        icon: "✨",
        benefits: ["Smooth lustrous finish", "Sculpting fit", "Gift-worthy"],
        bestFor: ["Day-to-night", "Gifting", "Special occasions"]
      },
      "cotton-premium": {
        label: "Cotton Sensation, Superior & Deluxe",
        icon: "🌾",
        benefits: ["Mercerised softness", "Breathable comfort", "Long-wearing quality"],
        bestFor: ["Everyday basics", "Men's & women's underwear", "Sleepwear"]
      },
      "cotton-seamless": {
        label: "Cotton Seamless",
        icon: "🪶",
        benefits: ["Invisible under clothing", "No-edge construction", "Lightweight feel"],
        bestFor: ["Under tailoring", "Travel", "Everyday wear"]
      },
      "cotton-lace": {
        label: "Cotton & Lace",
        icon: "🌸",
        benefits: ["Cotton comfort with delicate lace", "Pretty, feminine finish", "Easy-care"],
        bestFor: ["Everyday lingerie", "Soft daytime layers", "Sensitive skin"]
      },
      modal: {
        label: "Modal",
        icon: "🎋",
        benefits: ["Silky-soft drape", "Moisture-wicking", "Holds colour beautifully"],
        bestFor: ["Hot sleepers", "Sensitive skin", "Loungewear"]
      }
    },

    // Collections — verified handles from hanro.com.au/collections.json
    collections: {
      bras:             { url: "/collections/womens-bras", label: "Women's Bras" },
      briefs:           { url: "/collections/womens-briefs", label: "Women's Briefs" },
      "womens-underwear": { url: "/collections/womens-underwear", label: "Women's Underwear" },
      "womens-tops":    { url: "/collections/womens-tops-and-camis", label: "Women's Tops & Camis" },
      "womens-tank-tops": { url: "/collections/womens-tank-tops", label: "Women's Tank Tops" },
      pyjamas:          { url: "/collections/womens-pyjamas-by-hanro", label: "Women's Pyjamas" },
      nightdresses:     { url: "/collections/womens-nightdresses-new", label: "Women's Nightdresses" },
      "womens-nightwear": { url: "/collections/womens-nightwear-new", label: "Women's Nightwear" },
      "womens-sleepwear": { url: "/collections/womens-sleepwear-1", label: "Women's Sleepwear" },
      robes:            { url: "/collections/womens-robes-new", label: "Women's Robes" },
      "womens-loungewear": { url: "/collections/womens-loungewear-new", label: "Women's Loungewear" },
      "womens-lounge-pants": { url: "/collections/womens-lounge-pants-new", label: "Women's Lounge Pants" },
      "womens-pants":   { url: "/collections/womens-pants", label: "Women's Pants" },
      "womens-shop-all": { url: "/collections/womens-shop-all-new", label: "Shop All Women's" },
      "mens-underwear": { url: "/collections/mens-briefs", label: "Men's Underwear" },
      boxers:           { url: "/collections/mens-boxer-shorts-new", label: "Men's Boxer Shorts" },
      "mens-tops":      { url: "/collections/mens-tops-new", label: "Men's Tops" },
      "mens-pyjamas":   { url: "/collections/mens-pyjamas-new", label: "Men's Pyjamas" },
      "mens-nightwear": { url: "/collections/mens-nightwear-new", label: "Men's Nightwear" },
      "mens-sleepwear": { url: "/collections/mens-sleepwear", label: "Men's Sleepwear" },
      "mens-robes":     { url: "/collections/mens-robes-1", label: "Men's Robes" },
      "mens-loungewear": { url: "/collections/mens-loungewear-new", label: "Men's Loungewear" },
      "mens-lounge-pants": { url: "/collections/mens-lounge-pants", label: "Men's Lounge Pants" },
      "mens-shop-all":  { url: "/collections/mens-shop-all-new", label: "Shop All Men's" },
      lingerie:         { url: "/collections/lingerie", label: "Lingerie" },
      "soft-cup-bras":  { url: "/collections/womens-soft-cup-bras", label: "Soft Cup Bras" },
      moments:          { url: "/collections/moments", label: "Moments Collection" },
      "cotton-seamless":{ url: "/collections/cotton-seamless-new", label: "Cotton Seamless" },
      "cotton-sensation": { url: "/collections/cotton-sensation-new", label: "Cotton Sensation" },
      "cotton-superior":{ url: "/collections/cotton-superior-new", label: "Cotton Superior" },
      "cotton-deluxe":  { url: "/collections/cotton-deluxe-new", label: "Cotton Deluxe" },
      "cotton-essentials":{ url: "/collections/cotton-essentials", label: "Cotton Essentials" },
      "cotton-pure":    { url: "/collections/cotton-pure", label: "Cotton Pure" },
      "cotton-lace":    { url: "/collections/cotton-lace", label: "Cotton Lace" },
      "cotton-sleepwear": { url: "/collections/mercerised-cotton-collection", label: "Cotton Sleepwear" },
      ultralight:       { url: "/collections/ultralight-new", label: "Ultralight" },
      "satin-deluxe":   { url: "/collections/satin-deluxe-new", label: "Satin Deluxe" },
      "pure-silk":      { url: "/collections/pure-silk-new", label: "Pure Silk" },
      "night-day":      { url: "/collections/night-day-new", label: "Night & Day" },
      "touch-feeling":  { url: "/collections/touch-feeling-1", label: "Touch Feeling" },
      "invisible-cotton": { url: "/collections/invisibile-cotton", label: "Invisible Cotton" },
      "sea-island-cotton": { url: "/collections/sea-island-cotton", label: "Sea Island Cotton" },
      bridal:           { url: "/collections/the-bridal-edit", label: "The Bridal Edit" },
      gift:             { url: "/collections/hanro-gift-guide", label: "Gift Guide" },
      "best-sellers":   { url: "/collections/best-in-stock", label: "Best In Stock" },
      "new-arrivals":   { url: "/collections/new-arrivals", label: "New Arrivals" },
      basics:           { url: "/collections/womens-mens-basics", label: "Women's & Men's Basics" },
      accessories:      { url: "/collections/accessories", label: "Accessories" },
      sale:             { url: "/collections/sale", label: "Sale" },
      all:              { url: "/collections/shop-all", label: "Shop All" }
    },

    // Style concerns — covering the "why" customers buy
    styleConcerns: {
      "hot-sleeper": {
        label: "Hot Sleeper",
        icon: "🔥",
        description: "Overheats at night, night sweats, humid climates",
        recommended: ["pure-silk", "cotton-seamless", "modal"],
        tips: "Pure Silk and Modal regulate temperature beautifully, while Cotton Seamless keeps things light against the skin. Look for spaghetti tops, short nightdresses or lightweight briefs."
      },
      "cold-sleeper": {
        label: "Cold Sleeper",
        icon: "❄️",
        description: "Gets chilly at night, prefers layers",
        recommended: ["woolen-silk", "cotton-premium", "satin-deluxe"],
        tips: "Woolen Silk leggings and long-sleeve tops trap warmth softly. Pair Cotton Deluxe nightdresses with a robe for the coldest nights."
      },
      "sensitive-skin": {
        label: "Sensitive Skin",
        icon: "🌿",
        description: "Eczema, allergies, reacts to synthetic fabrics",
        recommended: ["cotton-premium", "pure-silk", "modal", "cotton-lace"],
        tips: "Hanro's mercerised cottons (Sensation, Superior, Pure) and Pure Silk are gentle, breathable, and widely loved by people with reactive skin."
      },
      bridal: {
        label: "Bridal & Getting Ready",
        icon: "💍",
        description: "Wedding morning, honeymoon, special occasion",
        recommended: ["satin-deluxe", "cotton-lace", "pure-silk"],
        tips: "Satin Deluxe sets and Cotton Lace pieces photograph beautifully on the morning. A long Pure Silk shirt or short nightdress makes a refined honeymoon piece."
      },
      everyday: {
        label: "Everyday Basics",
        icon: "🌱",
        description: "Daily underwear and basics — comfortable, low-maintenance",
        recommended: ["cotton-premium", "cotton-seamless", "cotton-lace"],
        tips: "Cotton Sensation, Cotton Seamless and the Moments line are Hanro's everyday workhorses — soft, breathable, and machine-washable on a delicate cycle."
      },
      gift: {
        label: "Gift",
        icon: "🎁",
        description: "Birthday, anniversary, Mother's Day, Father's Day",
        recommended: ["satin-deluxe", "pure-silk", "woolen-silk"],
        tips: "Satin Deluxe sets, Pure Silk shirts and Woolen Silk pieces are the most-gifted — universally loved and beautifully presented."
      },
      travel: {
        label: "Travel",
        icon: "✈️",
        description: "Weekend away, long-haul, packing light",
        recommended: ["pure-silk", "cotton-seamless", "modal"],
        tips: "Pure Silk and Cotton Seamless pack down to almost nothing and dry fast — ideal for long-haul or back-to-back nights away."
      },
      "day-to-night": {
        label: "Day-to-Night",
        icon: "🌟",
        description: "Pieces that work under clothing or as soft layers",
        recommended: ["cotton-seamless", "satin-deluxe", "pure-silk"],
        tips: "Cotton Seamless wears invisibly under tailoring, while Pure Silk and Satin Deluxe camis double as evening tops under a blazer."
      }
    },

    // Care & fabric notes
    careNotes: {
      "pure-silk":      { label: "Pure Silk", benefit: "Hand-wash cold or use a delicate cycle in a mesh bag — air dry out of direct sunlight" },
      "woolen-silk":    { label: "Woolen Silk", benefit: "Hand-wash cold with wool-safe detergent — lay flat to dry" },
      "satin-deluxe":   { label: "Satin Deluxe", benefit: "Hand-wash or 30°C delicate cycle — iron on low if needed" },
      "cotton-premium": { label: "Cotton Sensation / Superior / Deluxe", benefit: "Machine-wash 40°C — tumble dry low" },
      "cotton-seamless":{ label: "Cotton Seamless", benefit: "Machine-wash 40°C in a mesh bag — keep away from hooks and zips" },
      "cotton-lace":    { label: "Cotton & Lace", benefit: "Machine-wash 30°C in a mesh bag — lay flat to preserve the lace" },
      "modal":          { label: "Modal", benefit: "Machine-wash cold — line dry for best drape" }
    },

    // Bestsellers (curated)
    bestsellers: [
      { name: "Moments Midi Briefs", url: "/products/black-moments-midi-brief", description: "Hanro's most-loved cotton brief — soft, breathable, refined fit" },
      { name: "Moments Underwire Bra", url: "/products/black-moments-underwire-bra", description: "The everyday underwire — supportive without compromising on softness" },
      { name: "Cotton Superior Long Leg Boxer Brief", url: "/products/black-cotton-superior-long-leg-boxer-brief", description: "Premium men's cotton boxer brief — long-leg cut, mercerised hand-feel" },
      { name: "Pure Silk Spaghetti Top", url: "/products/pure-silk-spaghetti-top", description: "Pure Silk cami — wears as sleepwear or layers under tailoring" }
    ],

    // Size guide (AU/EU reference)
    sizeGuide: {
      XS: { bust: "79-82 cm", waist: "60-64 cm", hip: "87-90 cm", au: "6" },
      S:  { bust: "83-86 cm", waist: "65-69 cm", hip: "91-94 cm", au: "8" },
      M:  { bust: "87-91 cm", waist: "70-74 cm", hip: "95-99 cm", au: "10" },
      L:  { bust: "92-97 cm", waist: "75-80 cm", hip: "100-105 cm", au: "12" },
      XL: { bust: "98-103 cm", waist: "81-86 cm", hip: "106-111 cm", au: "14" }
    }
  };

  const CATEGORY_ICONS = {
    "Bras": "🩱",
    "Briefs": "🩲",
    "Underwear": "🩲",
    "Boxers": "👨",
    "Men's Underwear": "👨",
    "Nightdresses": "🌙",
    "Nightwear": "🌙",
    "Pyjamas": "✨",
    "Robes": "🧥",
    "Camis": "👚",
    "Tops": "👚",
    "Shirts": "👔",
    "Shorts": "🩳",
    "Pants": "👖",
    "Leisurewear": "🏠",
    "Loungewear": "🏠",
    "Basics": "⭐",
    "Accessories": "🎀",
    "You might also like": "✨"
  };

  // ── Product benefit data for rich upsell cards ──
  const PRODUCT_BENEFITS = {
    "black-moments-midi-brief": { benefit: "Hanro's most-loved cotton brief — soft, breathable, refined mid-rise fit", tags: ["Bestseller", "Cotton"] },
    "beige-cotton-seamless-mini-briefs": { benefit: "Invisible under tailoring — no-edge construction in mercerised cotton", tags: ["Seamless", "Cotton"] },
    "black-cotton-lace-thong": { benefit: "Cotton comfort with delicate lace at the leg — a daily favourite", tags: ["Cotton + Lace"] },
    "natural-satin-deluxe-boyleg": { benefit: "Satin Deluxe boyleg — sculpting fit with a smooth, lustrous finish", tags: ["Satin", "Luxe"] },
    "black-moments-underwire-bra": { benefit: "The everyday underwire — supportive without compromising on softness", tags: ["Bestseller", "Cotton"] },
    "cotton-lace-soft-cup-bra-1": { benefit: "Cotton Lace soft-cup bra — wirefree comfort with a pretty trim", tags: ["Cotton + Lace"] },
    "black-satin-deluxe-padded-bra-soft": { benefit: "Satin Deluxe padded soft bra — refined shape under everything", tags: ["Satin", "Luxe"] },
    "cotton-deluxe-l-slv-nightdress-90cm-1": { benefit: "Cotton Deluxe long-sleeve nightdress — soft, warm, perennial favourite", tags: ["Cotton", "Nightdress"] },
    "copy-of-moments-nw-3-4-slv-nightdress-100cm": { benefit: "Moments 3/4 sleeve nightdress — a sleeping classic in mercerised cotton", tags: ["Cotton", "Nightdress"] },
    "anilla-l-slv-nightdress-100cm": { benefit: "Anilla long-sleeve nightdress — refined cotton with delicate detail", tags: ["Cotton", "Nightdress"] },
    "night-day-robe-1": { benefit: "The Night & Day robe — breakfast-in-bed staple, beautifully soft", tags: ["Robe", "Loungewear"] },
    "pure-silk-spaghetti-top": { benefit: "Pure Silk cami — wears as sleepwear or layers under tailoring", tags: ["Pure Silk", "Versatile"] },
    "ultralight-spaghetti-top": { benefit: "Ultralight cami — barely-there base layer in soft cotton-modal", tags: ["Ultralight", "Modal"] },
    "pure-silk-l-slv-shirt": { benefit: "Pure Silk long-sleeve shirt — fluid, refined, day-to-night", tags: ["Pure Silk", "Refined"] },
    "black-iris-night-day-short-pants": { benefit: "Night & Day Iris short pants — the matching short for sleep or lounge", tags: ["Loungewear"] },
    "woolen-silk-leggings-1": { benefit: "Woolen Silk leggings — quiet warmth, skin-soft against the body", tags: ["Woolen Silk", "Winter"] },
    "black-cotton-superior-long-leg-boxer-brief": { benefit: "Premium men's cotton boxer brief — long-leg cut, mercerised hand-feel", tags: ["Bestseller", "Men's"] },
    "black-cotton-sensation-briefs": { benefit: "Cotton Sensation men's brief — soft, breathable everyday wear", tags: ["Men's", "Cotton"] },
    "accessoires-bag": { benefit: "The Hanro reversible cotton bag — easy to carry, easy to pair", tags: ["Accessories"] }
  };

  // ── Upsell engine — complementary product recommendations ──
  // Maps product categories/keywords -> up to 4 complementary products
  const UPSELL_RULES = [
    {
      // Bought a bra -> upsell matching brief + soft cup option + boyleg
      match: (products) => products.some(p => /\bbra\b/i.test(p.name || "")),
      upsells: [
        { id: "black-moments-midi-brief", reason: "Pair with the matching Moments midi brief — a coordinated everyday set" },
        { id: "natural-satin-deluxe-boyleg", reason: "Add a Satin Deluxe boyleg for occasion days" },
        { id: "beige-cotton-seamless-mini-briefs", reason: "Cotton Seamless minis for invisible wear under tailoring" }
      ]
    },
    {
      // Bought a brief / boyleg / thong -> upsell matching bra + complementary brief
      match: (products) => products.some(p => /brief|boyleg|thong|panty|panties/i.test(p.name || "")),
      upsells: [
        { id: "black-moments-underwire-bra", reason: "The matching Moments underwire bra completes the set" },
        { id: "cotton-lace-soft-cup-bra-1", reason: "A Cotton Lace soft-cup option for off-duty days" },
        { id: "black-cotton-lace-thong", reason: "Add a lace thong for variation through the week" }
      ]
    },
    {
      // Bought a nightdress -> upsell robe + matching cotton brief + pyjama short
      match: (products) => products.some(p => /nightdress|nightie|nightgown/i.test(p.name || "")),
      upsells: [
        { id: "night-day-robe-1", reason: "Throw the Night & Day robe over your nightdress in the mornings" },
        { id: "black-iris-night-day-short-pants", reason: "Add the matching short pant for warmer nights" },
        { id: "black-moments-midi-brief", reason: "Pair with a Moments cotton brief for a complete sleep set" }
      ]
    },
    {
      // Bought a robe -> upsell nightdress + cami + lounge short
      match: (products) => products.some(p => /robe|kimono|dressing gown/i.test(p.name || "")),
      upsells: [
        { id: "anilla-l-slv-nightdress-100cm", reason: "Wear a long-sleeve nightdress beneath your robe" },
        { id: "pure-silk-spaghetti-top", reason: "A Pure Silk cami underneath for breakfast-in-bed" },
        { id: "black-iris-night-day-short-pants", reason: "Layer with the matching short for lounge mornings" }
      ]
    },
    {
      // Bought a pyjama / set -> upsell robe + bra + cami
      match: (products) => products.some(p => /pyjama|pajama|pj\b|sleep set/i.test(p.name || "")),
      upsells: [
        { id: "night-day-robe-1", reason: "The Night & Day robe completes the sleep ritual" },
        { id: "ultralight-spaghetti-top", reason: "Add an Ultralight cami for warmer nights" },
        { id: "black-moments-midi-brief", reason: "Pair with the everyday Moments midi brief" }
      ]
    },
    {
      // Bought a cami / top -> upsell brief + bra + shirt
      match: (products) => products.some(p => /cami|spaghetti|top\b|tank/i.test(p.name || "")),
      upsells: [
        { id: "black-moments-midi-brief", reason: "Pair the cami with the Moments cotton brief" },
        { id: "black-moments-underwire-bra", reason: "Add the everyday Moments underwire bra" },
        { id: "pure-silk-l-slv-shirt", reason: "Layer a Pure Silk long-sleeve shirt over the cami for evenings" }
      ]
    },
    {
      // Bought a men's brief / boxer -> upsell complementary cotton lines + men's shirt
      match: (products) => products.some(p => /(boxer|brief).*\b(men|man|m\b)/i.test(((p.name || "") + " " + (p.tags || []).join(" "))) || /cotton sensation|cotton superior|cotton essentials/i.test(p.name || "")),
      upsells: [
        { id: "black-cotton-superior-long-leg-boxer-brief", reason: "The Cotton Superior long-leg boxer brief — premium everyday cut" },
        { id: "black-cotton-sensation-briefs", reason: "A Cotton Sensation brief for variation" }
      ]
    },
    {
      // Gift / special occasion query -> upsell luxe pieces
      match: (products) => products.some(p => /gift|present|wedding|anniversary|bridal|honeymoon/i.test(((p.name || "") + " " + (p.tags || []).join(" "))) ),
      upsells: [
        { id: "black-satin-deluxe-padded-bra-soft", reason: "Satin Deluxe padded soft bra — gift-worthy and beautifully presented" },
        { id: "natural-satin-deluxe-boyleg", reason: "The matching Satin Deluxe boyleg" },
        { id: "pure-silk-l-slv-shirt", reason: "A Pure Silk long-sleeve shirt — refined and universally loved" },
        { id: "woolen-silk-leggings-1", reason: "Woolen Silk leggings — quiet luxury, ideal winter gift" }
      ]
    }
  ];

  // Get upsell products for a set of shown products, excluding any already displayed
  // Filters by conversation context (category + fabric) so upsells are always relevant
  function getUpsellProducts(shownProducts) {
    const shownIds = new Set(shownProducts.map(p => p.id));
    const category = conversationContext.category || "";
    const fabric = conversationContext.fabricPreference || "";
    const occasion = conversationContext.occasion || "";

    for (const rule of UPSELL_RULES) {
      if (rule.match(shownProducts)) {
        let upsells = rule.upsells.filter(u => !shownIds.has(u.id));
        if (upsells.length === 0) continue;

        // Soft-filter by fabric preference
        if (fabric) {
          const withFabric = upsells.filter(u => {
            const product = getCatalogProductById(u.id);
            if (!product) return false;
            const tags = (product.tags || []).join(" ").toLowerCase();
            return tags.includes(fabric);
          });
          if (withFabric.length >= 2) upsells = withFabric;
        }

        // Soft-filter by occasion
        if (occasion === "bridal") {
          const bridal = upsells.filter(u => {
            const product = getCatalogProductById(u.id);
            if (!product) return false;
            const tags = (product.tags || []).join(" ").toLowerCase();
            return tags.includes("bridal") || tags.includes("lace");
          });
          if (bridal.length >= 2) upsells = bridal;
        }

        if (upsells.length === 0) continue;
        return upsells.slice(0, 4).map(u => {
          const catalogProduct = getCatalogProductById(u.id);
          if (!catalogProduct) return null;
          return { ...catalogProduct, upsellReason: u.reason };
        }).filter(Boolean);
      }
    }
    return [];
  }

  // Look up a single product from the fallback catalog by ID
  function getCatalogProductById(id) {
    // We'll search the knownProducts array inside getCatalogRecommendations
    // For efficiency, extract this as a top-level lookup
    const allProducts = getAllKnownProducts();
    return allProducts.find(p => p.id === id) || null;
  }

  // Centralized product list (used by both catalog search and upsell lookups)
  function getAllKnownProducts() {
    if (getAllKnownProducts._cache) return getAllKnownProducts._cache;
    // This will be populated after the catalog is defined below
    return [];
  }


  const qs = (sel, root = document) => root.querySelector(sel);
  const timeStr = () =>
    new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  function sleep(ms) { return new Promise((r) => setTimeout(r, ms)); }

  // ── SVG Icons ──
  const ICONS = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>',
    spinner: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4m0 12v4m-7.07-14.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/></svg>',
    circle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/></svg>',
    paw: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4.5-2c-.83 0-1.5.67-1.5 1.5S6.67 11 7.5 11 9 10.33 9 9.5 8.33 8 7.5 8zm9 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S17.33 8 16.5 8zM12 5c-.83 0-1.5.67-1.5 1.5S11.17 8 12 8s1.5-.67 1.5-1.5S12.83 5 12 5zm0 9c-2.21 0-4 1.12-4 2.5S9.79 19 12 19s4-1.12 4-2.5S14.21 14 12 14z"/></svg>',
  };

  // ── Scrape products from the current page (Shopify-based) ──
  function scrapePageProducts() {
    const products = [];
    const productElements = document.querySelectorAll(
      '[class*="product-card"], [class*="product-item"], [class*="ProductCard"], .grid-product, .product-grid-item, [data-product-id], .collection-product'
    );

    productElements.forEach(el => {
      try {
        const link = el.querySelector('a[href*="/products/"]') || el.closest('a[href*="/products/"]');
        const img = el.querySelector('img');
        const nameEl = el.querySelector('[class*="title"], [class*="name"], h2, h3, h4');
        const priceEl = el.querySelector('[class*="price"], .money');

        if (link) {
          products.push({
            id: link.href.split('/products/')[1]?.split('?')[0] || Math.random().toString(36),
            name: nameEl?.textContent?.trim() || img?.alt || '',
            image: img?.src || '',
            price: priceEl?.textContent?.trim() || '',
            url: link.href,
            element: el
          });
        }
      } catch(e) {}
    });

    return products;
  }

  // ── Image cache for Shopify product images (persistent) ──
  const IMAGE_CACHE_KEY = scopedStorageKey('imageCacheV1');
  let imageCache = {};
  try {
    const raw = localStorage.getItem(IMAGE_CACHE_KEY);
    if (raw) imageCache = JSON.parse(raw) || {};
  } catch (e) { imageCache = {}; }

  let _imgCacheSaveTimer = null;
  function saveImageCache() {
    clearTimeout(_imgCacheSaveTimer);
    _imgCacheSaveTimer = setTimeout(() => {
      try { localStorage.setItem(IMAGE_CACHE_KEY, JSON.stringify(imageCache)); } catch {}
    }, 500);
  }

  // Rewrite a Shopify CDN image URL to request a specific width variant.
  // Handles: protocol-relative //, size suffixes like _100x, _grande, explicit
  // ?width= params, and adds ?width= when missing. Safe no-op on bad input.
  function upgradeShopifyImage(url, width) {
    if (!url || typeof url !== 'string') return url || '';
    if (typeof width !== 'number') width = 800;
    try {
      if (url.startsWith('//')) url = 'https:' + url;
      url = url.replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|x\d+)(?=\.(jpg|jpeg|png|webp|gif))/i,
        ''
      );
      if (/[?&]width=/.test(url)) {
        url = url.replace(/([?&])width=\d+/, '$1width=' + width);
      } else {
        url += (url.includes('?') ? '&' : '?') + 'width=' + width;
      }
      return url;
    } catch (e) {
      return url;
    }
  }

  // Build a retina-ready srcset string from a Shopify CDN image URL.
  function buildShopifySrcset(url) {
    if (!url || typeof url !== 'string') return '';
    try {
      return [
        upgradeShopifyImage(url, 400) + ' 1x',
        upgradeShopifyImage(url, 800) + ' 2x',
        upgradeShopifyImage(url, 1200) + ' 3x'
      ].join(', ');
    } catch (e) {
      return '';
    }
  }

  // Fetch a single product's image from Shopify product JSON API
  async function fetchProductImage(handle) {
    if (!handle) return '';
    if (imageCache[handle]) return imageCache[handle];
    try {
      // Use relative URL — we're on the same origin
      const resp = await fetch(`/products/${handle}.json`);
      if (resp.ok) {
        const data = await resp.json();
        const rawImg = data?.product?.image?.src || data?.product?.images?.[0]?.src || '';
        const img = upgradeShopifyImage(rawImg, 600);
        if (img) { imageCache[handle] = img; saveImageCache(); return img; }
      }
    } catch (e) {}
    return '';
  }

  // Enrich products array with images from Shopify API
  async function enrichWithImages(products) {
    const needImages = products.filter(p => !p.image);
    if (needImages.length === 0) return products;

    const promises = needImages.map(async (p) => {
      const handle = p.url?.split('/products/')?.[1]?.split('?')?.[0];
      if (handle) {
        const img = await fetchProductImage(handle);
        if (img) p.image = img;
      }
    });

    await Promise.allSettled(promises);
    return products;
  }

  // ── Search products via Shopify JSON API (primary) ──

  // Generate progressively simpler query variants for Shopify search
  function generateQueryVariants(query) {
    const variants = [query]; // Start with original
    const words = query.toLowerCase().split(/\s+/);

    // Category keywords that Shopify is most likely to match on
    const categoryWords = ['bra', 'brief', 'boxer', 'thong', 'boyleg', 'underwear', 'nightdress', 'nightie', 'nightgown', 'pyjama', 'pajama', 'robe', 'cami', 'spaghetti', 'top', 'shirt', 'short', 'pant', 'legging', 'set', 'bag'];
    const fabricWords = ['silk', 'pure silk', 'woolen silk', 'wool', 'cotton', 'lace', 'satin', 'modal', 'viscose', 'seamless'];

    // Extract category and fabric words from the query
    const cats = words.filter(w => categoryWords.some(c => w.includes(c)));
    const fabs = words.filter(w => fabricWords.some(f => w.includes(f)));

    // Try fabric + category (e.g., "cotton brief", "pure silk top", "satin bra")
    if (fabs.length > 0 && cats.length > 0) {
      variants.push(`${fabs[0]} ${cats[0]}`);
    }

    // Try just category (e.g., "robe", "pyjama")
    if (cats.length > 0) {
      variants.push(cats[0]);
    }

    // Try just fabric (e.g., "silk")
    if (fabs.length > 0 && cats.length === 0) {
      variants.push(fabs[0]);
    }

    // Deduplicate
    return [...new Set(variants)];
  }

  async function tryShopifySuggestAPI(query) {
    try {
      const apiUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
      const resp = await fetch(apiUrl);
      if (resp.ok) {
        const data = await resp.json();
        console.log("[HANRO AI] Suggest API raw response for '" + query + "':", JSON.stringify(data).substring(0, 500));
        const items = data?.resources?.results?.products || [];
        if (items.length > 0) {
          const mapped = items.map(p => {
            const productUrl = p.url || '';
            const handle = productUrl.replace('/products/', '').split('?')[0] || p.handle || '';
            const fullUrl = productUrl.startsWith('/') ? SITE_BASE + productUrl : (productUrl.startsWith('http') ? productUrl : SITE_BASE + '/products/' + handle);
            return {
              id: handle || p.id || Math.random().toString(36).substr(2, 8),
              name: p.title || '',
              image: upgradeShopifyImage(p.image || p.featured_image || '', 600),
              price: p.price ? (p.price.toString().startsWith('$') ? p.price : `$${p.price}`) : '',
              url: fullUrl
            };
          });
          console.log("[HANRO AI] Suggest API found", mapped.length, "products for query '" + query + "'");
          return mapped;
        }
      }
    } catch (e) {
      console.log("[HANRO AI] Shopify suggest API failed for '" + query + "':", e);
    }
    return null;
  }

  async function tryBackendRecommendAPI(query) {
    if (!AI_RECOMMEND_ENDPOINT) return null;
    try {
      const resp = await fetch(AI_RECOMMEND_ENDPOINT, {
        method: "POST",
        credentials: GINIA_AI_CONFIG.recommendFetchCredentials || GINIA_AI_CONFIG.fetchCredentials || "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          shopId: SHOP_ID,
          message: query,
          context: conversationContext,
          limit: 8
        })
      });

      if (!resp.ok) {
        console.log("[HANRO AI] Recommend API unavailable for '" + query + "':", resp.status);
        return null;
      }

      const data = await resp.json();
      const products = Array.isArray(data?.products) ? data.products : [];
      if (products.length === 0) return null;

      console.log("[HANRO AI] Recommend API found", products.length, "products for query '" + query + "'", data.source || "");
      return products.map(p => ({
        id: p.id || p.handle || Math.random().toString(36).substr(2, 8),
        name: p.name || p.title || "",
        image: upgradeShopifyImage(p.image || "", 600),
        price: p.price || "",
        url: p.url && p.url.startsWith("http") ? p.url : SITE_BASE + (p.url || `/products/${p.handle || p.id || ""}`),
        tags: p.tags || [],
        recommendationReason: p.recommendationReason || ""
      }));
    } catch (e) {
      console.log("[HANRO AI] Recommend API failed for '" + query + "':", e);
    }
    return null;
  }

  async function searchSiteProducts(query) {
    console.log("[HANRO AI] Searching for:", query);

    // Method 1: Use the backend recommendation engine when available. It
    // filters the full Shopify export and asks Gemini to rerank the best
    // candidates, while this frontend keeps local fallbacks for resilience.
    const recommendedResults = await tryBackendRecommendAPI(query);
    if (recommendedResults && recommendedResults.length > 0) {
      return await enrichWithImages(recommendedResults);
    }

    // Method 2: Use the curated local catalog. Shopify predictive search
    // can return a generic catch-all of popular items for many different queries,
    // which makes distinct searches look identical.
    const catalogResults = getCatalogRecommendations(query);
    if (catalogResults.length > 0 && catalogResults[0].id !== "browse-collection") {
      console.log("[HANRO AI] Catalog search found", catalogResults.length, "products for:", query);
      return await enrichWithImages(catalogResults);
    }

    // Method 3: Try Shopify Predictive Search API with progressively simpler queries
    const variants = generateQueryVariants(query);
    for (const variant of variants) {
      const results = await tryShopifySuggestAPI(variant);
      if (results && results.length > 0) {
        return await enrichWithImages(results);
      }
    }

    // Method 4: Shopify search results page as JSON (try simplified queries too)
    for (const variant of variants.slice(0, 2)) {
      try {
        const searchResp = await fetch(`/search?q=${encodeURIComponent(variant)}&type=product&view=json`);
        if (searchResp.ok) {
          const text = await searchResp.text();
          try {
            const searchData = JSON.parse(text);
            if (Array.isArray(searchData) && searchData.length > 0) {
              console.log("[HANRO AI] Search JSON view found", searchData.length, "products for '" + variant + "'");
              return searchData.map(p => ({
                id: p.handle || p.id || '',
                name: p.title || '',
                image: upgradeShopifyImage(p.featured_image || p.image || '', 600),
                price: p.price ? `$${p.price}` : '',
                url: SITE_BASE + (p.url || `/products/${p.handle || ''}`)
              }));
            }
          } catch(e) { /* not JSON — expected for most themes */ }
        }
      } catch (e) {}
    }

    // Method 5: Fallback to a collection link
    console.log("[HANRO AI] Using catalog fallback for:", query);
    return catalogResults;
  }

  // ── Iframe fallback search ──
  async function searchViaIframe(query) {
    const searchUrl = `${SITE_BASE}/search?q=${encodeURIComponent(query)}&type=product`;

    return new Promise((resolve) => {
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:500px;height:700px;opacity:0;pointer-events:none;";
      iframe.src = searchUrl;
      document.body.appendChild(iframe);

      const timeout = setTimeout(() => {
        clearInterval(poll);
        iframe.remove();
        resolve(getCatalogRecommendations(query));
      }, 12000);

      let attempts = 0;
      const poll = setInterval(() => {
        attempts++;
        try {
          const doc = iframe.contentDocument;
          if (doc && doc.readyState === 'complete') {
            const products = [];
            const items = doc.querySelectorAll(
              '[class*="product-card"], [class*="product-item"], .grid-product, .product-grid-item, [data-product-id], .collection-product, .search-result'
            );

            items.forEach(el => {
              try {
                const link = el.querySelector('a[href*="/products/"]') || el.closest('a[href*="/products/"]');
                const img = el.querySelector('img');
                const nameEl = el.querySelector('[class*="title"], [class*="name"], h2, h3, h4, p');
                const priceEl = el.querySelector('[class*="price"], .money');

                if (link) {
                  const href = link.href || link.getAttribute('href') || '';
                  const fullUrl = href.startsWith('http') ? href : SITE_BASE + href;
                  products.push({
                    id: href.split('/products/')[1]?.split('?')[0] || Math.random().toString(36).substr(2, 8),
                    name: nameEl?.textContent?.trim() || img?.alt?.trim() || '',
                    image: img?.src || img?.dataset?.src || '',
                    price: priceEl?.textContent?.trim() || '',
                    url: fullUrl
                  });
                }
              } catch(e) {}
            });

            if (products.length > 0 || attempts > 15) {
              clearInterval(poll);
              clearTimeout(timeout);
              iframe.remove();
              resolve(products.length > 0 ? products : getCatalogRecommendations(query));
              return;
            }
          }
        } catch (e) {}

        if (attempts > 20) {
          clearInterval(poll);
          clearTimeout(timeout);
          iframe.remove();
          resolve(getCatalogRecommendations(query));
        }
      }, 500);
    });
  }

  // ── Fallback: Generate catalog-based product recommendations ──
  // ── Complete product catalog with REAL verified URLs ──
  // Shared by catalog search fallback AND upsell engine
  const KNOWN_PRODUCTS = [];

  // Wire up the shared product lookup used by upsell engine
  getAllKnownProducts._cache = KNOWN_PRODUCTS;

  function getCatalogRecommendations(query) {
    const q = query.toLowerCase();

    // Category tags carry the highest weight — these define what the product IS
    const CATEGORY_TAGS = ['bra', 'brief', 'boxer', 'thong', 'boyleg', 'underwear', 'nightdress', 'nightie', 'nightgown', 'pyjama', 'pajama', 'robe', 'cami', 'spaghetti', 'top', 'shirt', 'short', 'pant', 'legging', 'set', 'bag'];
    // Fabric tags are secondary — they describe material
    const FABRIC_TAGS = ['silk', 'pure-silk', 'woolen-silk', 'wool', 'cotton', 'lace', 'satin', 'modal', 'viscose', 'seamless'];
    // Occasion / collection tags
    const OCCASION_TAGS = ['daywear', 'nightwear', 'sleepwear', 'loungewear', 'leisurewear', 'basics', 'best-sellers', 'new-arrivals', 'sale'];

    // Score and filter with weighted matching
    const STOP_WORDS = new Set([
      "a", "an", "and", "are", "for", "i", "me", "my", "of", "please", "show",
      "the", "to", "want", "with", "you"
    ]);
    const queryWords = q
      .split(/\s+/)
      .map(w => w.replace(/[^a-z0-9-]/g, ""))
      .filter(w => w.length > 1 && !STOP_WORDS.has(w));
    const requestedCategories = CATEGORY_TAGS.filter(c =>
      queryWords.some(w => w.includes(c) || c.includes(w.replace(/s$/, "")))
    );

    const scored = KNOWN_PRODUCTS.map(p => {
      let score = 0;
      const nameLower = p.name.toLowerCase();
      const productTags = p.tags || [];
      queryWords.forEach(word => {
        if (word.length < 2) return;
        const singular = word.replace(/s$/, "");
        // Category match is highest priority (slip, robe, pyjama, etc.)
        const isCategoryWord = CATEGORY_TAGS.some(c => singular.includes(c) || c.includes(singular));
        const isFabricWord = FABRIC_TAGS.some(f => singular.includes(f) || f.includes(singular));

        productTags.forEach(tag => {
          if (tag.includes(singular) || singular.includes(tag)) {
            if (isCategoryWord) {
              score += 10; // Heavy weight for category match in tags
            } else if (isFabricWord) {
              score += 1;  // Fabric is useful, but should not swamp category
            } else {
              score += 2;  // Default tag match
            }
          }
        });

        // Name match
        if (nameLower.includes(singular)) {
          score += isCategoryWord ? 8 : 3;
        }
      });
      if (requestedCategories.length > 0) {
        const hasRequestedCategory = requestedCategories.some(c =>
          productTags.includes(c) ||
          (c === "pajama" && productTags.includes("pyjama")) ||
          (c === "pyjama" && productTags.includes("pajama")) ||
          (c === "short" && productTags.includes("shorts"))
        );
        if (!hasRequestedCategory) score -= 20;
      }
      return { ...p, _score: score };
    }).filter(p => p._score > 0).sort((a, b) => b._score - a._score);

    if (scored.length > 0) {
      return scored.slice(0, 6).map(({ _score, tags, ...rest }) => ({ ...rest, image: "" }));
    }

    // Determine best collection to link to
    const collections = PRODUCT_CATALOG.collections;
    let bestCollection = collections.all;
    for (const [key, col] of Object.entries(collections)) {
      if (q.includes(key)) { bestCollection = col; break; }
    }

    return [{
      id: "browse-collection",
      name: `Browse ${bestCollection.label}`,
      image: "",
      price: "",
      url: SITE_BASE + bestCollection.url
    }];
  }

  // ── Shopify Cart API ──
  const variantCache = {};
  const siblingsCache = {};
  const livePriceCache = {};
  const shownPostCartUpsells = new Set();

  function getShopifyRouteRoot() {
    const rootPath = window.Shopify?.routes?.root || "/";
    return rootPath.endsWith("/") ? rootPath : rootPath + "/";
  }

  function normalizeProductHandle(value) {
    return String(value || "")
      .replace(/^https?:\/\/[^/]+/i, "")
      .replace(/^\/+|\/+$/g, "")
      .replace(/^products\//, "")
      .split("?")[0]
      .split("#")[0];
  }

  function activeCurrencyCode() {
    return window.Shopify?.currency?.active ||
      window.Shopify?.currency?.shopCurrency ||
      GINIA_AI_CONFIG.currency ||
      "";
  }

  function moneyValueToCents(value) {
    if (value == null || value === "") return null;
    if (typeof value === "number") {
      return Math.round(Number.isInteger(value) ? value : value * 100);
    }
    const cleaned = String(value).replace(/[^0-9.]/g, "");
    if (!cleaned) return null;
    const numeric = Number(cleaned);
    if (!Number.isFinite(numeric)) return null;
    return Math.round(cleaned.includes(".") ? numeric * 100 : numeric);
  }

  function formatLiveMoney(cents) {
    const currency = activeCurrencyCode();
    if (currency && typeof Intl !== "undefined" && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency,
          minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {}
    }
    if (window.Shopify?.formatMoney && window.Shopify?.money_format) {
      try {
        const html = window.Shopify.formatMoney(cents, window.Shopify.money_format);
        const tmp = document.createElement("span");
        tmp.innerHTML = html;
        return (tmp.textContent || html || "").trim();
      } catch (e) {}
    }
    return "$" + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  function formatLivePriceRange(minCents, maxCents) {
    if (minCents == null) return "";
    if (maxCents == null || maxCents === minCents) return formatLiveMoney(minCents);
    return `${formatLiveMoney(minCents)} - ${formatLiveMoney(maxCents)}`;
  }

  function priceFromProductPayload(product) {
    if (!product) return "";
    const variantPrices = Array.isArray(product.variants)
      ? product.variants.map(v => moneyValueToCents(v.price)).filter(v => v != null)
      : [];
    const minCents = moneyValueToCents(product.price_min ?? product.priceMin ?? product.price) ??
      (variantPrices.length ? Math.min(...variantPrices) : null);
    const maxCents = moneyValueToCents(product.price_max ?? product.priceMax ?? product.price) ??
      (variantPrices.length ? Math.max(...variantPrices) : minCents);
    return formatLivePriceRange(minCents, maxCents);
  }

  function extractPriceFromProductPage(html) {
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const candidates = [
        "[data-product-price]",
        "[data-price]",
        ".price .money",
        ".price-item--sale",
        ".price-item--regular",
        ".price__regular .price-item",
        ".price__sale .price-item",
        "[class*='price'] .money",
        "[class*='price']"
      ];
      for (const selector of candidates) {
        const el = doc.querySelector(selector);
        const text = el?.textContent?.replace(/\s+/g, " ").trim();
        if (text && /[$€£¥]|[A-Z]{3}|\d/.test(text)) return text;
      }
    } catch (e) {}
    return "";
  }

  async function fetchLiveProductPrice(handle) {
    handle = normalizeProductHandle(handle);
    if (!handle || handle === "browse-collection") return "";
    const cacheKey = `${activeCurrencyCode() || "default"}:${handle}`;
    if (livePriceCache[cacheKey]) return livePriceCache[cacheKey];

    livePriceCache[cacheKey] = (async () => {
      const routeRoot = getShopifyRouteRoot();
      const productPath = `${routeRoot}products/${encodeURIComponent(handle)}`;

      try {
        const resp = await fetch(`${productPath}.js`, { credentials: "same-origin" });
        if (resp.ok) {
          const price = priceFromProductPayload(await resp.json());
          if (price) return price;
        }
      } catch (e) {}

      try {
        const resp = await fetch(`${productPath}.json`, { credentials: "same-origin" });
        if (resp.ok) {
          const price = priceFromProductPayload((await resp.json())?.product);
          if (price) return price;
        }
      } catch (e) {}

      try {
        const resp = await fetch(productPath, { credentials: "same-origin" });
        if (resp.ok) return extractPriceFromProductPage(await resp.text());
      } catch (e) {}

      return "";
    })();

    return livePriceCache[cacheKey];
  }

  function ensureCardPriceEl(card) {
    let priceEl = card.querySelector(".bell-ai-product-price");
    if (priceEl) return priceEl;
    const info = card.querySelector(".bell-ai-product-info");
    const nameEl = card.querySelector(".bell-ai-product-name");
    if (!info || !nameEl) return null;
    priceEl = document.createElement("div");
    priceEl.className = "bell-ai-product-price";
    nameEl.insertAdjacentElement("afterend", priceEl);
    return priceEl;
  }

  function refreshLiveProductPrices(root = document) {
    const cards = Array.from(root.querySelectorAll(".bell-ai-product[data-handle]"));
    cards.forEach((card) => {
      const handle = normalizeProductHandle(card.dataset.handle);
      if (!handle || handle === "browse-collection") return;
      const priceEl = ensureCardPriceEl(card);
      if (!priceEl) return;
      priceEl.dataset.livePrice = "loading";
      fetchLiveProductPrice(handle).then((price) => {
        if (!price || !priceEl.isConnected) return;
        priceEl.textContent = price;
        priceEl.dataset.livePrice = "ready";
      }).catch(() => {
        if (priceEl.isConnected) priceEl.dataset.livePrice = "failed";
      });
    });
  }

  async function fetchProductVariants(handle) {
    if (!handle) { console.error("[HANRO AI] fetchProductVariants called with empty handle"); return { variants: [], options: [] }; }
    // Clean handle — strip leading/trailing slashes, query params
    handle = handle.replace(/^\/+|\/+$/g, '').split('?')[0];
    if (variantCache[handle]) return variantCache[handle];

    const normalizeOptions = (rawOptions) => (rawOptions || []).map((o, idx) => (
      typeof o === 'string'
        ? { name: o, position: idx + 1, values: [] }
        : { name: o.name || '', position: o.position || idx + 1, values: o.values || [] }
    ));
    const normalizeVariants = (rawVariants) => (rawVariants || []).map(v => ({
      id: Number(v.id),
      title: v.title || 'Default',
      price: v.price ? (typeof v.price === 'number' ? formatLiveMoney(moneyValueToCents(v.price)) : `$${v.price}`) : '',
      available: v.available !== false,
      option1: v.option1 || '',
      option2: v.option2 || '',
      option3: v.option3 || '',
      featured_image: v.featured_image?.src || v.featured_image || ''
    }));

    try {
      // Use Shopify's product JS endpoint first because it includes live
      // availability for each variant.
      console.log("[HANRO AI] Fetching variants for handle:", handle);
      const jsResp = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (jsResp.ok) {
        const data = await jsResp.json();
        const variants = normalizeVariants(data?.variants || []);
        const options = normalizeOptions(data?.options || []);
        console.log("[HANRO AI] Fetched variants for", handle, ":", variants.length, "variants");
        if (variants.length > 0) {
          const result = { variants, options };
          variantCache[handle] = result;
          return result;
        }
      }

      const resp = await fetch(`/products/${handle}.json`);
      if (resp.ok) {
        const data = await resp.json();
        const rawVariants = data?.product?.variants || [];
        const rawOptions = data?.product?.options || [];
        console.log("[HANRO AI] Fetched variants for", handle, ":", rawVariants.length, "variants");
        const variants = normalizeVariants(rawVariants);
        const options = normalizeOptions(rawOptions);
        if (variants.length > 0) {
          const result = { variants, options };
          variantCache[handle] = result;
          return result;
        }
      } else {
        console.error("[HANRO AI] Variant fetch failed for", handle, "status:", resp.status);
      }
    } catch (e) { console.error("[HANRO AI] Failed to fetch variants for", handle, e); }
    return { variants: [], options: [] };
  }

  async function addToCart(variantId, quantity = 1) {
    // Ensure variant ID is a number
    const numericId = Number(variantId);
    if (!numericId || isNaN(numericId)) {
      console.error("[HANRO AI] Invalid variant ID:", variantId);
      return { success: false, error: "Invalid variant ID", status: 0 };
    }
    console.log("[HANRO AI] Adding to cart, variant:", numericId, "quantity:", quantity);
    try {
      // Single form-encoded POST. Shopify accepts form and JSON equivalently;
      // retrying just gets us rate-limited.
      const params = new URLSearchParams();
      params.append("id", String(numericId));
      params.append("quantity", String(quantity));

      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: params.toString(),
        credentials: 'same-origin'
      });

      if (resp.ok) {
        const data = await resp.json();
        console.log("[HANRO AI] Added to cart successfully:", data);
        // Trigger Shopify theme cart update event
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh')); } catch(e) {}
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(e) {}
        return { success: true, data: data, status: resp.status };
      }

      const errText = resp.status === 429 ? 'rate limited' : await resp.text().catch(() => '');
      console.error("[HANRO AI] Add to cart failed:", resp.status, errText.slice(0, 200));
      return { success: false, error: `Status ${resp.status}`, status: resp.status };
    } catch (e) {
      console.error("[HANRO AI] Add to cart error:", e);
      return { success: false, error: e.message, status: 0 };
    }
  }

  // Fallback: scrape product page for variant ID and add to cart
  async function addToCartViaForm(handle) {
    try {
      console.log("[HANRO AI] Trying form fallback for handle:", handle);
      // Fetch the product page HTML
      const pageResp = await fetch(`/products/${handle}`);
      if (!pageResp.ok) {
        console.error("[HANRO AI] Could not load product page for", handle, "status:", pageResp.status);
        return false;
      }
      const html = await pageResp.text();

      // Extract variant ID from the page HTML
      // Shopify pages typically have: "id":VARIANT_ID in product JSON or name="id" value="VARIANT_ID"
      let variantId = null;

      // Method 1: Look for product JSON in the page
      const jsonMatch = html.match(/"variants"\s*:\s*\[([^\]]+)\]/);
      if (jsonMatch) {
        const idMatch = jsonMatch[1].match(/"id"\s*:\s*(\d+)/);
        if (idMatch) variantId = Number(idMatch[1]);
      }

      // Method 2: Look for hidden form input
      if (!variantId) {
        const inputMatch = html.match(/name="id"[^>]*value="(\d+)"/);
        if (inputMatch) variantId = Number(inputMatch[1]);
      }

      // Method 3: Look in Shopify meta/config
      if (!variantId) {
        const metaMatch = html.match(/variant[s]?.*?(\d{10,})/);
        if (metaMatch) variantId = Number(metaMatch[1]);
      }

      if (variantId) {
        console.log("[HANRO AI] Found variant ID from page:", variantId, "— adding to cart");
        const result = await addToCart(variantId);
        return result.success;
      }

      console.error("[HANRO AI] Could not extract variant ID from product page");
      return false;
    } catch (e) {
      console.error("[HANRO AI] Form fallback error:", e);
      return false;
    }
  }

  // HTML-escape a user-visible string so it can safely appear in an attribute.
  function escAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function escText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Figure out which option slot (1/2/3) is "Size" and which is "Color".
  // Returns { sizeIdx, colorIdx } — either may be null if not present.
  function classifyOptions(options) {
    const result = { sizeIdx: null, colorIdx: null, sizeName: 'Size', colorName: 'Color' };
    (options || []).forEach(o => {
      const n = (o.name || '').toLowerCase();
      const slot = o.position; // 1-indexed
      if (!slot) return;
      if (/size|fit/.test(n) && result.sizeIdx == null) { result.sizeIdx = slot; result.sizeName = o.name || 'Size'; }
      else if (/colou?r|shade|hue/.test(n) && result.colorIdx == null) { result.colorIdx = slot; result.colorName = o.name || 'Color'; }
    });
    return result;
  }

  // Colour name -> swatch hex. HANRO's palette is mostly refined neutrals plus seasonal tones
  // with some signature proprietary names. Generic English words too so compound
  // names like "Dusty Rose" resolve via fallback word matching.
  const COLOR_SWATCHES = {
    // ---- Neutrals / blacks / whites ---------------------------------------
    'black': '#1a1a1a', 'jet black': '#1a1a1a', 'noir': '#1a1a1a',
    'deep black': '#121212', 'onyx': '#14141a', 'ink': '#121218',
    'charcoal': '#3a3a3a',
    'white': '#ffffff', 'off white': '#f4efe6', 'ivory': '#f4efe6',
    'creme': '#efe8d9', 'cream': '#efe8d9', 'porcelain': '#f2ece0',
    'pearl': '#ede8e0', 'moon': '#e4e1da', 'natural': '#e8dccc',
    'champagne': '#e8dcc4', 'vanilla': '#f4e8c8',
    // ---- Greys / silvers --------------------------------------------------
    'grey': '#8a8a8a', 'gray': '#8a8a8a', 'silver': '#c7c7c7',
    'dove': '#bcb8b0', 'dove grey': '#bcb8b0', 'dove gray': '#bcb8b0',
    'smoke': '#8a8d89', 'platinum': '#d4d4ce',
    // ---- Beige / sand / tan / browns --------------------------------------
    'beige': '#d7c6ab', 'nude': '#e7c9b1', 'skin': '#e3b99b',
    'sand': '#d4c09a', 'dune': '#c8b494', 'taupe': '#a59378',
    'mink': '#a89580', 'mushroom': '#a89580', 'mocha': '#7d5f49',
    'caramel': '#b8854a', 'cognac': '#8c5a32', 'chocolate': '#3f2a1e',
    'walnut': '#5e3a20', 'coffee': '#4a3326',
    // ---- Pinks / blushes / roses ------------------------------------------
    'blush': '#e8c9c5', 'blush pink': '#e8c9c5', 'rose': '#d9a3a3',
    'dusty rose': '#c9a0a0', 'rosewater': '#f0d4d1', 'pink': '#e6b7c0',
    'petal': '#f2d6d8', 'ballet': '#f4d4d0', 'peach': '#f2c1a8',
    'powder pink': '#f0d4d6', 'soft pink': '#f0cfd2', 'bonbon': '#f0a9b9',
    // ---- Reds / burgundies ------------------------------------------------
    'red': '#a8302a', 'ruby': '#7a1c28', 'cherry': '#a81b2c',
    'wine': '#5a1b22', 'burgundy': '#6e1f25', 'garnet': '#7a1f28',
    'berry': '#7a1f3a', 'merlot': '#5f1a26',
    // ---- Blues ------------------------------------------------------------
    'blue': '#2d4a7a', 'navy': '#17243f', 'deep navy': '#17243f',
    'midnight': '#1a2338', 'midnight blue': '#1a2338', 'indigo': '#2a3558',
    'sky': '#a9c3dc', 'powder blue': '#bfd3e0', 'sky blue': '#a9c3dc',
    'dusty blue': '#7a95ad', 'denim': '#5a7aa0', 'slate': '#5a6a7a',
    'cornflower': '#6a7fb5', 'sapphire': '#1e3a78', 'cobalt': '#2c4fb0',
    // ---- Greens -----------------------------------------------------------
    'green': '#3a5a3a', 'sage': '#aab79a', 'mint': '#b8d7c4',
    'olive': '#6a6a3c', 'moss': '#6a7a40', 'emerald': '#1f6b47',
    'forest': '#2f4a33', 'pine': '#2a4a35',
    // ---- Purples / lavenders ---------------------------------------------
    'purple': '#5a3a6a', 'amethyst': '#7a5ba0', 'plum': '#5b2a55',
    'lavender': '#c9b6dc', 'lilac': '#bfa7cf', 'mauve': '#a07aa0',
    'orchid': '#a85ba8',
    // ---- Yellows / golds / oranges ---------------------------------------
    'yellow': '#e6c868', 'gold': '#c9a857', 'mustard': '#b8872a',
    'honey': '#d4a85c', 'amber': '#b8793c', 'apricot': '#efb88a',
    'coral': '#e79b8a', 'terracotta': '#b8663a',
    // ---- Prints / patterns (pick a dominant tone) -------------------------
    'brushstroke zebra': '#2a2a2a', 'brushstroke zebra print': '#2a2a2a',
    'leopard': '#a87c4a', 'floral': '#d4a8a0', 'animal print': '#a87c4a',
    'paisley': '#8a6a4a', 'polka dot': '#a8a8a8'
  };

  function swatchFor(name) {
    if (!name) return '#c8a87c';
    const raw = String(name).toLowerCase().trim()
      .replace(/[\u2012-\u2015–—]/g, '-');
    const parts = raw.split(/\s*\/\s*/).map(s => s.trim()).filter(Boolean);
    const primary = parts[0] || raw;
    const candidates = parts.length > 1
      ? [primary, raw, ...parts.slice(1)]
      : [raw];
    for (const k of candidates) if (COLOR_SWATCHES[k]) return COLOR_SWATCHES[k];
    const stripped = primary
      .replace(/\s+(print|stripe|check|pattern|tiles|ornaments|paisley|form[s]?|mosaic|damask)\b/g, '')
      .trim();
    if (stripped && stripped !== primary && COLOR_SWATCHES[stripped]) {
      return COLOR_SWATCHES[stripped];
    }
    const words = stripped.split(/[\s\-]+/).filter(Boolean);
    for (let i = words.length - 1; i >= 0; i--) {
      if (COLOR_SWATCHES[words[i]]) return COLOR_SWATCHES[words[i]];
    }
    for (let i = 0; i < words.length; i++) {
      if (COLOR_SWATCHES[words[i]]) return COLOR_SWATCHES[words[i]];
    }
    // Unknown — satin taupe default so the picker never looks broken.
    return '#c8a87c';
  }

  // Find other color variants sold as separate products sharing the same title.
  async function fetchSiblingColorProducts(handle, title) {
    if (!title) return [];
    const norm = s => String(s || '')
      .toLowerCase()
      .replace(/[\u2012-\u2015\-–—_]/g, ' ')
      .replace(/[^a-z0-9 ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    const normTitle = norm(title);
    if (!normTitle) return [];

    if (siblingsCache[normTitle]) {
      return siblingsCache[normTitle].filter(s => s.handle !== handle);
    }

    try {
      const q = encodeURIComponent(title);
      const resp = await fetch(
        `/search/suggest.json?q=${q}&resources%5Btype%5D=product&resources%5Blimit%5D=20`,
        { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }
      );
      if (!resp.ok) return [];
      const data = await resp.json();
      const products = data?.resources?.results?.products || [];

      const candidates = [];
      const seen = new Set();
      products.forEach(p => {
        if (!p || !p.handle || seen.has(p.handle)) return;
        if (norm(p.title) !== normTitle) return;
        seen.add(p.handle);
        candidates.push(p);
      });
      if (candidates.length === 0) {
        siblingsCache[normTitle] = [];
        return [];
      }

      const resolved = await Promise.all(candidates.map(async (p) => {
        try {
          const r = await fetchProductVariants(p.handle);
          if (!r || !r.variants || r.variants.length === 0) return null;
          const cls = classifyOptions(r.options);
          let color = '';
          if (cls.colorIdx) {
            const colorOpt = (r.options || []).find(o => o.position === cls.colorIdx);
            color = (colorOpt && colorOpt.values && colorOpt.values[0]) || '';
          }
          if (!color) {
            const candidates2 = [r.variants[0]?.option1, r.variants[0]?.option2, r.variants[0]?.option3];
            for (const v of candidates2) {
              if (v && COLOR_SWATCHES[String(v).toLowerCase()]) { color = v; break; }
            }
          }
          if (!color && Array.isArray(p.tags)) {
            color = p.tags.find(t => COLOR_SWATCHES[String(t).toLowerCase()]) || '';
          }
          if (!color) return null;
          const anyAvailable = r.variants.some(v => v.available);
          if (!anyAvailable) return null;
          const variantImg = r.variants.find(v => v.featured_image)?.featured_image || '';
          return {
            handle: p.handle,
            color,
            image: variantImg || p.featured_image?.url || p.image || '',
            available: anyAvailable,
            title: p.title || title,
            variants: r.variants,
            options: r.options
          };
        } catch (e) {
          console.warn('[HANRO AI] Sibling JSON fetch failed:', p.handle, e);
          return null;
        }
      }));

      const byColor = new Map();
      resolved.filter(Boolean).forEach(s => {
        const key = s.color.toLowerCase();
        const existing = byColor.get(key);
        if (!existing) byColor.set(key, s);
        else if (!existing.image && s.image) byColor.set(key, s);
      });
      const siblings = Array.from(byColor.values());
      siblingsCache[normTitle] = siblings;
      return siblings.filter(s => s.handle !== handle);
    } catch (e) {
      console.warn("[HANRO AI] Sibling lookup failed:", e);
      return [];
    }
  }

  // Render the inline size picker as a full-width row in the products grid,
  // directly after the row containing the clicked product card.
  function renderSizePicker(productCard, variants, handle, productName, options, siblingColors) {
    if (!productCard) return;
    const grid = productCard.closest('.bell-ai-products-grid');
    if (!grid) return;

    const btn = productCard.querySelector('.bell-ai-cart-btn');
    if (btn) {
      btn.textContent = 'Add to Cart';
      btn.classList.remove('bell-ai-cart-btn-loading');
    }

    grid.querySelectorAll('.bell-ai-size-picker').forEach(p => p.remove());
    grid.querySelectorAll('.bell-ai-product-selected')
        .forEach(el => el.classList.remove('bell-ai-product-selected'));

    const computed = getComputedStyle(grid);
    const columns = Math.max(
      1,
      (computed.gridTemplateColumns || '').trim().split(/\s+/).filter(Boolean).length || 3
    );

    const cards = Array.from(grid.querySelectorAll('.bell-ai-product'));
    const cardIdx = cards.indexOf(productCard);
    const rowIdx = Math.floor(cardIdx / columns);
    const lastInRow = Math.min((rowIdx + 1) * columns - 1, cards.length - 1);
    const anchor = cards[lastInRow];

    productCard.classList.add('bell-ai-product-selected');

    const cls = classifyOptions(options);
    const getVal = (v, idx) => idx === 1 ? v.option1 : idx === 2 ? v.option2 : idx === 3 ? v.option3 : '';

    const distinctColors = [];
    const distinctSizes = [];
    const seenColors = new Set();
    const seenSizes = new Set();
    variants.forEach(v => {
      if (!v.available) return;
      if (cls.colorIdx) {
        const c = (getVal(v, cls.colorIdx) || '').trim();
        if (c && !seenColors.has(c)) { seenColors.add(c); distinctColors.push(c); }
      }
      if (cls.sizeIdx) {
        const s = (getVal(v, cls.sizeIdx) || '').trim();
        if (s && !seenSizes.has(s)) { seenSizes.add(s); distinctSizes.push(s); }
      }
    });

    const colors = [];
    const seenColorKey = new Set();
    const pushColor = (name, prodHandle, image, variantList, availOverride) => {
      if (!name) return;
      if (availOverride === false) return;
      const key = name.toLowerCase();
      if (seenColorKey.has(key)) return;
      seenColorKey.add(key);
      colors.push({
        color: name,
        handle: prodHandle,
        image: image || '',
        variants: variantList || null,
        available: availOverride !== false
      });
    };
    distinctColors.forEach(c => {
      const variantWithImg = variants.find(v => (getVal(v, cls.colorIdx) || '').trim() === c && v.featured_image);
      const img = variantWithImg ? variantWithImg.featured_image : '';
      const anyAvailable = variants.some(v => v.available && (getVal(v, cls.colorIdx) || '').trim() === c);
      pushColor(c, handle, img, variants, anyAvailable);
    });
    (siblingColors || []).forEach(s => {
      if (s.available === false) return;
      pushColor(s.color, s.handle, s.image, null, s.available);
    });

    const hasColor = colors.length > 1;
    const hasSize = cls.sizeIdx && distinctSizes.length > 0;

    let activeColor = '';
    if (hasColor) {
      const mine = colors.find(c => c.handle === handle && c.available);
      activeColor = (mine && mine.color) ||
                    (colors.find(c => c.available)?.color) ||
                    colors[0]?.color ||
                    '';
    }
    const activeEntry = hasColor
      ? (colors.find(c => c.color === activeColor) || colors[0])
      : { color: '', handle, image: '', variants };

    const picker = document.createElement('div');
    picker.className = 'bell-ai-size-picker';
    if (hasColor) picker.classList.add('bell-ai-size-picker-with-color');
    picker.dataset.productHandle = activeEntry.handle;
    picker.dataset.productName = productName || '';

    picker.__giniaColors = colors;
    picker.__giniaActiveColor = activeColor;
    picker.__giniaOptions = cls;
    picker.__giniaVariants = activeEntry.variants || variants;
    picker.__giniaProductName = productName || '';

    picker.innerHTML =
      `<button class="bell-ai-size-picker-close" type="button" aria-label="Close picker">×</button>` +
      (hasColor
        ? `<div class="bell-ai-size-picker-section bell-ai-size-picker-colors">` +
            `<div class="bell-ai-size-picker-label"><span>Select ${escText(cls.colorName || 'Colour')}</span></div>` +
            `<div class="bell-ai-size-picker-options bell-ai-size-picker-colors-row">` +
              renderColorChipsFromColors(colors, activeColor) +
            `</div>` +
          `</div>`
        : '') +
      (hasSize
        ? `<div class="bell-ai-size-picker-section bell-ai-size-picker-sizes">` +
            `<div class="bell-ai-size-picker-label"><span>Select ${escText(cls.sizeName || 'Size')}</span></div>` +
            `<div class="bell-ai-size-picker-options bell-ai-size-picker-sizes-row">` +
              renderSizeChips(activeEntry.variants || variants, cls, activeEntry.handle, productName, activeEntry.color) +
            `</div>` +
          `</div>`
        : `<div class="bell-ai-size-picker-section">` +
            `<div class="bell-ai-size-picker-label"><span>Select option</span></div>` +
            `<div class="bell-ai-size-picker-options">` +
              (activeEntry.variants || variants).filter(v => v.available).map(v => {
                const label = (v.title || '').trim() || 'One size';
                return (
                  `<button type="button" class="bell-ai-size-chip" ` +
                    `data-variant-id="${v.id}" ` +
                    `data-handle="${escAttr(handle)}" ` +
                    `data-product-name="${escAttr(productName || '')}">` +
                    `${escText(label)}` +
                  `</button>`
                );
              }).join('') +
            `</div>` +
          `</div>`
      );

    if (anchor.nextSibling) {
      grid.insertBefore(picker, anchor.nextSibling);
    } else {
      grid.appendChild(picker);
    }

    requestAnimationFrame(() => {
      const cardRect = productCard.getBoundingClientRect();
      const pickerRect = picker.getBoundingClientRect();
      const arrowLeft = (cardRect.left + cardRect.width / 2) - pickerRect.left;
      picker.style.setProperty('--bell-ai-picker-arrow-left', arrowLeft + 'px');
      try { picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    });

    if (hasColor && activeColor) {
      swapCardImageForColor(productCard, variants, cls, activeColor);
    }
  }

  function renderColorChipsFromColors(colors, activeColor) {
    return (colors || []).filter(c => c.available !== false).map(c => {
      const isActive = c.color === activeColor;
      const hex = swatchFor(c.color);
      const classes = ['bell-ai-color-chip'];
      if (isActive) classes.push('bell-ai-color-chip-active');
      return (
        `<button type="button" class="${classes.join(' ')}" ` +
          `data-color="${escAttr(c.color)}" ` +
          `data-handle="${escAttr(c.handle)}" ` +
          `title="${escAttr(c.color)}" ` +
          `aria-label="${escAttr(c.color)}">` +
          `<span class="bell-ai-color-chip-swatch" style="background:${hex}"></span>` +
          `<span class="bell-ai-color-chip-label">${escText(c.color)}</span>` +
        `</button>`
      );
    }).join('');
  }

  function renderSizeChips(variants, cls, handle, productName, activeColor) {
    const getC = v => cls.colorIdx ? ((cls.colorIdx === 1 ? v.option1 : cls.colorIdx === 2 ? v.option2 : v.option3) || '').trim() : '';
    const getS = v => cls.sizeIdx ? ((cls.sizeIdx === 1 ? v.option1 : cls.sizeIdx === 2 ? v.option2 : v.option3) || '').trim() : '';

    const bySize = new Map();
    variants.forEach(v => {
      if (!v.available) return;
      const s = getS(v);
      if (!s) return;
      if (activeColor && getC(v) !== activeColor) return;
      if (!bySize.has(s)) bySize.set(s, v);
    });

    const ordered = [];
    const seen = new Set();
    variants.forEach(v => {
      if (!v.available) return;
      const s = getS(v);
      if (!s || seen.has(s)) return;
      if (activeColor && getC(v) !== activeColor) return;
      seen.add(s);
      ordered.push(s);
    });

    return ordered.map(s => {
      const v = bySize.get(s);
      return (
        `<button type="button" class="bell-ai-size-chip" ` +
          `data-variant-id="${v.id}" ` +
          `data-handle="${escAttr(handle)}" ` +
          `data-product-name="${escAttr(productName || '')}">` +
          `${escText(s)}` +
        `</button>`
      );
    }).join('');
  }

  function swapCardImageToUrl(card, rawUrl) {
    if (!card || !rawUrl) return;
    const img = card.querySelector('.bell-ai-product-img img');
    if (!img) return;
    const newSrc = upgradeShopifyImage(rawUrl, 800);
    const strip = s => String(s || '').replace(/_\d+x\d*(?=\.[a-z]+)/i, '').split('?')[0];
    if (strip(img.src) === strip(newSrc)) return;

    const newSrcset = buildShopifySrcset(rawUrl);
    img.style.transition = 'opacity 0.22s cubic-bezier(0.4, 0, 0.2, 1)';
    img.style.opacity = '0';

    setTimeout(() => {
      const onReady = () => { img.style.opacity = '1'; };
      img.addEventListener('load', onReady, { once: true });
      img.addEventListener('error', onReady, { once: true });
      if (newSrcset) img.srcset = newSrcset;
      img.src = newSrc;
      if (img.complete && img.naturalWidth > 0) onReady();
    }, 150);
  }

  function swapCardImageForColor(card, variants, cls, color) {
    if (!card || !cls || !cls.colorIdx || !color) return;
    const getC = v => ((cls.colorIdx === 1 ? v.option1 : cls.colorIdx === 2 ? v.option2 : v.option3) || '').trim();
    const match = variants.find(v => getC(v) === color && v.featured_image);
    if (!match) return;
    swapCardImageToUrl(card, match.featured_image);
  }

  async function activatePickerColor(picker, newColor, clickedChip) {
    if (!picker || !picker.__giniaColors) return;
    const entry = picker.__giniaColors.find(c => c.color === newColor);
    if (!entry) return;
    publishAnalyticsEvent("variant_color_selected", getProductAnalyticsData(entry.handle, picker.__giniaProductName || picker.dataset.productName || "", {
      color: newColor
    }));

    picker.__giniaActiveColor = newColor;
    picker.querySelectorAll('.bell-ai-color-chip').forEach(c => {
      c.classList.toggle('bell-ai-color-chip-active', c === clickedChip);
    });

    const sizeRow = picker.querySelector('.bell-ai-size-picker-sizes-row');
    if (!entry.variants) {
      if (sizeRow) {
        sizeRow.innerHTML = `<span class="bell-ai-size-picker-loading">Loading sizes…</span>`;
      }
      const r = await fetchProductVariants(entry.handle);
      entry.variants = r.variants;
      entry.options = r.options;
      const vImg = r.variants.find(v => v.featured_image)?.featured_image;
      if (vImg) entry.image = vImg;
    }

    picker.dataset.productHandle = entry.handle;
    picker.__giniaVariants = entry.variants || [];

    if (sizeRow) {
      const clsForEntry = entry.options
        ? classifyOptions(entry.options)
        : picker.__giniaOptions;
      sizeRow.innerHTML = renderSizeChips(
        entry.variants || [],
        clsForEntry,
        entry.handle,
        picker.__giniaProductName || picker.dataset.productName || '',
        entry.color
      );
    }

    const grid = picker.closest('.bell-ai-products-grid');
    const card = grid?.querySelector('.bell-ai-product-selected');
    if (card && entry.image) swapCardImageToUrl(card, entry.image);
  }

  function upgradePickerWithSiblings(picker, newSiblings) {
    if (!picker || !picker.__giniaColors) return;
    const seen = new Set(picker.__giniaColors.map(c => c.color.toLowerCase()));
    let added = 0;
    newSiblings.forEach(s => {
      if (!s.color) return;
      if (seen.has(s.color.toLowerCase())) return;
      seen.add(s.color.toLowerCase());
      picker.__giniaColors.push({
        color: s.color,
        handle: s.handle,
        image: s.image || '',
        variants: s.variants || null,
        options: s.options || null,
        available: s.available !== false
      });
      added++;
    });
    if (added === 0) return;

    const activeColor = picker.__giniaActiveColor ||
      (picker.__giniaColors[0] && picker.__giniaColors[0].color) || '';

    let colorRow = picker.querySelector('.bell-ai-size-picker-colors-row');
    if (!colorRow) {
      picker.classList.add('bell-ai-size-picker-with-color');
      const cls = picker.__giniaOptions || {};
      const colorSection = document.createElement('div');
      colorSection.className = 'bell-ai-size-picker-section bell-ai-size-picker-colors';
      colorSection.innerHTML =
        `<div class="bell-ai-size-picker-label"><span>Select ${escText(cls.colorName || 'Colour')}</span></div>` +
        `<div class="bell-ai-size-picker-options bell-ai-size-picker-colors-row">` +
          renderColorChipsFromColors(picker.__giniaColors, activeColor) +
        `</div>`;
      const sizeSection = picker.querySelector('.bell-ai-size-picker-sizes');
      if (sizeSection) {
        picker.insertBefore(colorSection, sizeSection);
      } else {
        picker.appendChild(colorSection);
      }
    } else {
      colorRow.innerHTML = renderColorChipsFromColors(picker.__giniaColors, activeColor);
    }
  }

  function dismissSizePicker(productCard, cb) {
    const grid = productCard?.closest('.bell-ai-products-grid');
    const picker = grid?.querySelector('.bell-ai-size-picker');
    if (grid) {
      grid.querySelectorAll('.bell-ai-product-selected')
          .forEach(el => el.classList.remove('bell-ai-product-selected'));
    }
    if (!picker) { if (cb) cb(); return; }
    picker.classList.add('bell-ai-size-picker-leaving');
    setTimeout(() => { picker.remove(); if (cb) cb(); }, 220);
  }

  function flashPickerError(productCard, message) {
    const grid = productCard?.closest('.bell-ai-products-grid');
    const picker = grid?.querySelector('.bell-ai-size-picker');
    if (!picker) return;
    const sizeSection = picker.querySelector('.bell-ai-size-picker-sizes');
    const label = (sizeSection || picker).querySelector('.bell-ai-size-picker-label');
    if (!label) return;
    const span = label.querySelector('span');
    if (!span) return;
    const original = span.textContent;
    span.textContent = message;
    label.classList.add('bell-ai-size-picker-label-error');
    setTimeout(() => {
      if (!label.isConnected) return;
      span.textContent = original;
      label.classList.remove('bell-ai-size-picker-label-error');
    }, 2400);
  }

  function markAdded(buttonEl, handle, productName) {
    buttonEl.textContent = '✓ Added!';
    buttonEl.classList.remove('bell-ai-cart-btn-loading');
    buttonEl.classList.add('bell-ai-cart-btn-success');
    analyticsState.addToCartSuccesses += 1;
    markCartAttributed("agent_add_to_cart");
    publishAnalyticsEvent("add_to_cart_success", getProductAnalyticsData(handle, productName));
    updateCartCount();
    showPostCartUpsell(handle, productName);
    setTimeout(() => resetButton(buttonEl), 2500);
  }

  function markViewOnly(buttonEl, handle) {
    buttonEl.textContent = 'View Product';
    buttonEl.classList.remove('bell-ai-cart-btn-loading');
    buttonEl.onclick = () => openProduct(handle);
  }

  function resetButton(buttonEl) {
    if (!buttonEl || !buttonEl.isConnected) return;
    buttonEl.textContent = 'Add to Cart';
    buttonEl.classList.remove('bell-ai-cart-btn-success', 'bell-ai-cart-btn-disabled', 'bell-ai-cart-btn-loading');
    buttonEl.onclick = null;
  }

  function openProduct(handle) {
    try { saveSession(); } catch (e) {}
    publishAnalyticsEvent("product_opened", getProductAnalyticsData(handle, ""));
    window.location.href = `/products/${handle}`;
  }

  async function showPostCartUpsell(handle, productName) {
    const key = String(handle || productName || '').toLowerCase();
    if (!key || shownPostCartUpsells.has(key)) return;
    shownPostCartUpsells.add(key);

    const baseProduct = getCatalogProductById(handle) || {
      id: handle || productName || 'added-product',
      name: productName || 'Your pick',
      url: handle ? SITE_BASE + '/products/' + handle : SITE_BASE,
      tags: []
    };

    const upsellHTML = await buildUpsellHTML([baseProduct]);
    if (!upsellHTML) return;

    addBotBubble("Lovely choice — I’ve added it to your cart. Here are a few pieces that pair well with it:", false);
    addBotBubble(upsellHTML, false);
    publishAnalyticsEvent("upsell_shown", getProductAnalyticsData(handle, productName));
  }

  async function attemptAdd(triggerEl, variantId, handle, productName) {
    const isChip = triggerEl.classList.contains('bell-ai-size-chip');
    const grid = triggerEl.closest('.bell-ai-products-grid');
    const productCard = isChip
      ? (grid?.querySelector('.bell-ai-product-selected') || null)
      : triggerEl.closest('.bell-ai-product');
    const originalChipLabel = isChip ? triggerEl.textContent : null;
    publishAnalyticsEvent("add_to_cart_attempt", getProductAnalyticsData(handle, productName, {
      variantId,
      source: isChip ? "size_picker" : "product_card"
    }));

    if (isChip) {
      triggerEl.classList.add('bell-ai-size-chip-loading');
      triggerEl.disabled = true;
    } else {
      triggerEl.textContent = 'Adding…';
      triggerEl.classList.add('bell-ai-cart-btn-loading');
    }

    const result = await addToCart(variantId);
    console.log("[HANRO AI] addToCart result:", result);

    if (result.success) {
      if (isChip && productCard) {
        dismissSizePicker(productCard, () => {
          const btn = productCard.querySelector('.bell-ai-cart-btn');
          if (btn) markAdded(btn, handle, productName);
        });
      } else {
        markAdded(triggerEl, handle, productName);
      }
      return;
    }

    if (result.status === 429) {
      publishAnalyticsEvent("add_to_cart_failed", getProductAnalyticsData(handle, productName, {
        variantId,
        status: result.status,
        reason: "rate_limited"
      }));
      if (isChip && productCard) {
        dismissSizePicker(productCard, () => {
          const btn = productCard.querySelector('.bell-ai-cart-btn');
          if (!btn) return;
          btn.textContent = 'Too many requests — View';
          btn.classList.remove('bell-ai-cart-btn-loading');
          btn.classList.add('bell-ai-cart-btn-disabled');
          btn.onclick = () => openProduct(handle);
        });
      } else {
        triggerEl.textContent = 'Too many requests';
        triggerEl.classList.remove('bell-ai-cart-btn-loading');
        triggerEl.classList.add('bell-ai-cart-btn-disabled');
        triggerEl.onclick = () => openProduct(handle);
      }
      return;
    }

    if (isChip) {
      publishAnalyticsEvent("add_to_cart_failed", getProductAnalyticsData(handle, productName, {
        variantId,
        status: result.status,
        reason: result.error || "unknown"
      }));
      triggerEl.classList.remove('bell-ai-size-chip-loading');
      triggerEl.disabled = false;
      triggerEl.textContent = originalChipLabel;
      flashPickerError(productCard, "Couldn't add — try another size");
    } else {
      publishAnalyticsEvent("add_to_cart_failed", getProductAnalyticsData(handle, productName, {
        variantId,
        status: result.status,
        reason: result.error || "unknown"
      }));
      triggerEl.textContent = 'Failed — Retry';
      triggerEl.classList.remove('bell-ai-cart-btn-loading');
    }
  }

  // Entry point when a shopper clicks Add to Cart. Fetches variants, then
  // either adds directly (single variant) or shows the inline size picker.
  async function showVariantSelector(handle, productName, buttonEl) {
    if (!handle) {
      console.error("[HANRO AI] No handle for add to cart");
      buttonEl.textContent = 'Error';
      return;
    }
    analyticsState.addToCartClicks += 1;
    markCartAttributed("agent_engaged");
    publishAnalyticsEvent("add_to_cart_clicked", getProductAnalyticsData(handle, productName));
    const productCard = buttonEl.closest('.bell-ai-product');
    console.log("[HANRO AI] Add to Cart clicked — handle:", handle, "product:", productName);

    buttonEl.textContent = 'Loading sizes…';
    buttonEl.classList.add('bell-ai-cart-btn-loading');

    let { variants, options } = await fetchProductVariants(handle);

    // Fallback: if handle had a full URL mixed in, try cleaning it
    if (variants.length === 0 && handle.includes('/products/')) {
      const cleanHandle = handle.split('/products/').pop()?.split('?')[0] || '';
      if (cleanHandle && cleanHandle !== handle) {
        const retry = await fetchProductVariants(cleanHandle);
        variants = retry.variants;
        options = retry.options;
      }
    }

    if (variants.length === 0) {
      console.warn("[HANRO AI] No variants found — trying form fallback");
      publishAnalyticsEvent("variant_lookup_empty", getProductAnalyticsData(handle, productName));
      buttonEl.textContent = 'Adding…';
      const formResult = await addToCartViaForm(handle);
      buttonEl.classList.remove('bell-ai-cart-btn-loading');
      if (formResult) {
        markAdded(buttonEl, handle, productName);
      } else {
        publishAnalyticsEvent("add_to_cart_fallback_failed", getProductAnalyticsData(handle, productName));
        markViewOnly(buttonEl, handle);
      }
      return;
    }

    const availableCount = variants.filter(v => v.available).length;
    console.log("[HANRO AI] Variants:", variants.length, "/ available:", availableCount);

    if (availableCount === 0) {
      publishAnalyticsEvent("product_sold_out", getProductAnalyticsData(handle, productName, { variants: variants.length }));
      buttonEl.textContent = 'Sold Out';
      buttonEl.classList.remove('bell-ai-cart-btn-loading');
      buttonEl.classList.add('bell-ai-cart-btn-disabled');
      return;
    }

    const isSingleVariant = variants.length === 1 ||
      (variants.length > 0 && variants.every(v => /default title/i.test(v.title || '')));
    if (isSingleVariant) {
      const only = variants.find(v => v.available) || variants[0];
      await attemptAdd(buttonEl, only.id, handle, productName);
      return;
    }

    buttonEl.classList.remove('bell-ai-cart-btn-loading');
    publishAnalyticsEvent("variant_selector_shown", getProductAnalyticsData(handle, productName, {
      variants: variants.length,
      availableVariants: availableCount,
      optionNames: options.map(o => o.name).filter(Boolean)
    }));

    const cls = classifyOptions(options);
    const intrinsicColors = new Set();
    if (cls.colorIdx) {
      variants.forEach(v => {
        const c = (cls.colorIdx === 1 ? v.option1 : cls.colorIdx === 2 ? v.option2 : v.option3) || '';
        if (c) intrinsicColors.add(c.trim());
      });
    }
    const alreadyMultiColor = intrinsicColors.size > 1;

    renderSizePicker(productCard, variants, handle, productName, options, []);

    if (alreadyMultiColor) return;

    fetchSiblingColorProducts(handle, productName).then(siblings => {
      const others = (siblings || []).filter(s => s.handle !== handle);
      if (others.length === 0) return;
      const grid = productCard.closest('.bell-ai-products-grid');
      const picker = grid?.querySelector('.bell-ai-size-picker');
      if (!picker) return;
      if ((picker.dataset.productName || '') !== (productName || '')) return;
      upgradePickerWithSiblings(picker, others);
    }).catch(() => {});
  }

  // Update cart count in both the extension badge AND the site's own cart UI
  function updateCartCount() {
    try {
      fetch(`/cart.js`).then(r => r.json()).then(cart => {
        const count = cart.item_count || 0;

        // Update extension's own cart badge
        const badge = document.getElementById('bellAiCartBadge');
        if (badge) {
          badge.textContent = count;
          badge.style.display = count > 0 ? 'flex' : 'none';
        }

        // Also update the site's native cart count selectors
        const countEls = document.querySelectorAll(
          '[data-cart-count], .cart-count, .cart-count-bubble, .js-cart-count, .cart-link__count, .site-header__cart-count'
        );
        countEls.forEach(el => { el.textContent = count; });
      });
    } catch (e) {}
  }

  // ── Build product card HTML (with Add to Cart) ──
  function productCardHTML(p) {
    const altSafe = escAttr(p.name || '');
    const nameSafe = escText(p.name || '');
    const reasonSafe = escText(p.recommendationReason || '');
    const imgHTML = p.image
      ? `<img src="${upgradeShopifyImage(p.image, 800)}" srcset="${buildShopifySrcset(p.image)}" sizes="160px" alt="${altSafe}" loading="lazy" decoding="async" style="width:100%;height:100%;object-fit:cover;">`
      : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#f3e9e0;font-size:32px;">👘</div>`;

    const priceHTML = p.price ? `<div class="bell-ai-product-price">${escText(p.price)}</div>` : '';
    const reasonHTML = reasonSafe ? `<div class="bell-ai-product-reason">${reasonSafe}</div>` : '';
    const handle = p.url?.split('/products/')?.[1]?.split('?')?.[0] || p.id || '';

    return (
      `<div class="bell-ai-product" data-product-id="${escAttr(p.id)}" data-handle="${escAttr(handle)}">` +
      `<a href="${escAttr(p.url)}" style="text-decoration:none;color:inherit">` +
      `<div class="bell-ai-product-img">${imgHTML}</div>` +
      `<div class="bell-ai-product-info">` +
      `<div class="bell-ai-product-name">${nameSafe}</div>` +
      priceHTML +
      reasonHTML +
      `</div></a>` +
      `<button class="bell-ai-cart-btn" data-handle="${escAttr(handle)}" data-product-name="${altSafe}">Add to Cart</button>` +
      `</div>`
    );
  }

  // Build rich upsell card HTML with benefit info
  function upsellCardHTML(p) {
    const altSafe = (p.name || '').replace(/"/g, '&quot;');
    const imgHTML = p.image
      ? `<img src="${upgradeShopifyImage(p.image, 800)}" srcset="${buildShopifySrcset(p.image)}" sizes="160px" alt="${altSafe}" loading="lazy" decoding="async" style="width:100%;height:100%;object-fit:cover;">`
      : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#f3e9e0;font-size:32px;">👘</div>`;

    const priceHTML = p.price ? `<div class="bell-ai-product-price">${p.price}</div>` : '';
    const handle = p.url?.split('/products/')?.[1]?.split('?')?.[0] || p.id || '';

    // Get benefit data
    const benefits = PRODUCT_BENEFITS[p.id] || {};
    const reasonHTML = p.upsellReason ? `<div class="bell-ai-upsell-why">${p.upsellReason}</div>` : '';
    const benefitHTML = benefits.benefit ? `<div class="bell-ai-upsell-benefit">${benefits.benefit}</div>` : '';
    const tagsHTML = benefits.tags && benefits.tags.length > 0
      ? `<div class="bell-ai-upsell-tags">${benefits.tags.map(t => `<span class="bell-ai-upsell-tag">${t}</span>`).join('')}</div>`
      : '';

    return (
      `<div class="bell-ai-product bell-ai-upsell-card" data-product-id="${p.id}" data-handle="${handle}">` +
      `<a href="${p.url}" style="text-decoration:none;color:inherit">` +
      `<div class="bell-ai-product-img">${imgHTML}</div>` +
      `<div class="bell-ai-product-info">` +
      `<div class="bell-ai-product-name">${p.name}</div>` +
      priceHTML +
      reasonHTML +
      benefitHTML +
      tagsHTML +
      `</div></a>` +
      `<button class="bell-ai-cart-btn" data-handle="${handle}" data-product-name="${altSafe}">Add to Cart</button>` +
      `</div>`
    );
  }

  // Build upsell section HTML with "You might also like" header
  async function buildUpsellHTML(shownProducts) {
    const upsells = getUpsellProducts(shownProducts);
    if (upsells.length === 0) return '';

    // Enrich upsells with images
    const enriched = await enrichWithImages(upsells);

    let html = '<div class="bell-ai-upsell-section">';
    html += '<div class="bell-ai-upsell-header"><span class="bell-ai-upsell-icon">✨</span> Pairs well with your picks</div>';
    html += '<div class="bell-ai-products-grid">';
    enriched.slice(0, 4).forEach(p => {
      html += upsellCardHTML(p);
    });
    html += '</div></div>';
    return html;
  }

  function buildCategoryHTML(categoryName, items) {
    const icon = CATEGORY_ICONS[categoryName] || "🐾";
    let html = '<div class="bell-ai-category-section">';
    html += `<div class="bell-ai-category-header"><span class="bell-ai-category-icon">${icon}</span>${categoryName}</div>`;
    html += '<div class="bell-ai-products-grid">';
    items.forEach((p) => { html += productCardHTML(p); });
    html += "</div></div>";
    return html;
  }

  function buildStyleCard(concernKey) {
    const concern = PRODUCT_CATALOG.styleConcerns[concernKey];
    if (!concern) return '';
    return `<div class="bell-ai-health-card">
      <div class="bell-ai-health-card-header">${concern.icon} ${concern.label}</div>
      <div class="bell-ai-health-card-desc">${concern.tips}</div>
    </div>`;
  }

  // ── Build fabric comparison HTML (Hanro fabric families) ──
  function buildFabricGuideHTML(pureSilkNote, woolenSilkNote, satinNote, cottonPremiumNote, cottonSeamlessNote, modalNote) {
    return `<div class="bell-ai-fabric-guide">
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">💫 Pure Silk</div>
        <div class="bell-ai-fabric-note">${pureSilkNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Temperature regulating</span><span class="bell-ai-tag">Refined</span></div>
      </div>
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">🧶 Woolen Silk</div>
        <div class="bell-ai-fabric-note">${woolenSilkNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Winter warmth</span><span class="bell-ai-tag">Quietly luxurious</span></div>
      </div>
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">✨ Satin Deluxe</div>
        <div class="bell-ai-fabric-note">${satinNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Lustrous finish</span><span class="bell-ai-tag">Gift-worthy</span></div>
      </div>
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">🌾 Cotton Sensation, Superior & Deluxe</div>
        <div class="bell-ai-fabric-note">${cottonPremiumNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Mercerised softness</span><span class="bell-ai-tag">Everyday</span></div>
      </div>
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">🪶 Cotton Seamless</div>
        <div class="bell-ai-fabric-note">${cottonSeamlessNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Invisible wear</span><span class="bell-ai-tag">No-edge</span></div>
      </div>
      <div class="bell-ai-fabric-card">
        <div class="bell-ai-fabric-header">🎋 Modal</div>
        <div class="bell-ai-fabric-note">${modalNote}</div>
        <div class="bell-ai-fabric-tags"><span class="bell-ai-tag">Silky drape</span><span class="bell-ai-tag">Moisture-wicking</span></div>
      </div>
    </div>`;
  }

  // ── Page context ──
  function getPageContext() {
    const path = window.location.pathname.toLowerCase();
    const title = document.title || '';

    // Specific category-bearing collections (must match before generic women/men checks)
    if (path.includes("/collections/womens-bras") || path.includes("/collections/womens-soft-cup-bras")) return { type: "collection", label: "bras", category: "bra" };
    if (path.includes("/collections/womens-briefs") || path.includes("/collections/womens-underwear")) return { type: "collection", label: "briefs", category: "briefs" };
    if (path.includes("/collections/mens-briefs") || path.includes("/collections/mens-white-underwear") || path.includes("/collections/mens-trend-underwear")) return { type: "collection", label: "men's underwear", category: "mens-underwear" };
    if (path.includes("/collections/mens-boxer-shorts")) return { type: "collection", label: "boxer shorts", category: "boxers" };
    if (path.includes("/collections/womens-tops-and-camis") || path.includes("/collections/womens-tank-tops") || path.includes("/collections/womens-lounge-tops")) return { type: "collection", label: "tops and camisoles", category: "cami" };
    if (path.includes("/collections/mens-tops") || path.includes("/collections/mens-tak-tops") || path.includes("/collections/mens-loungewear-tops")) return { type: "collection", label: "men's tops", category: "top" };
    if (path.includes("/collections/womens-robes")) return { type: "collection", label: "robes", category: "robe" };
    if (path.includes("/collections/mens-robes")) return { type: "collection", label: "men's robes", category: "robe" };
    if (path.includes("/collections/womens-pyjamas") || path.includes("/collections/womens-pyjamas-by-hanro")) return { type: "collection", label: "pyjamas", category: "pyjama" };
    if (path.includes("/collections/mens-pyjamas") || path.includes("/collections/men-pyjamas")) return { type: "collection", label: "men's pyjamas", category: "pyjama" };
    if (path.includes("/collections/womens-nightdresses")) return { type: "collection", label: "nightdresses", category: "nightdress" };
    if (path.includes("/collections/womens-nightwear") || path.includes("/collections/womens-sleepwear")) return { type: "collection", label: "nightwear", category: "nightdress" };
    if (path.includes("/collections/mens-nightwear") || path.includes("/collections/mens-sleepwear")) return { type: "collection", label: "men's sleepwear", category: "pyjama" };
    if (path.includes("/collections/womens-loungewear") || path.includes("/collections/womens-lounge")) return { type: "collection", label: "loungewear", category: "leisurewear" };
    if (path.includes("/collections/mens-loungewear") || path.includes("/collections/mens-lounge") || path.includes("/collections/mens-living")) return { type: "collection", label: "men's loungewear", category: "leisurewear" };
    if (path.includes("/collections/womens-pants") || path.includes("/collections/womens-lounge-pants")) return { type: "collection", label: "pants", category: "pants" };
    if (path.includes("/collections/mens-lounge-pants")) return { type: "collection", label: "men's lounge pants", category: "pants" };

    // Fabric / line collections
    if (path.includes("/collections/pure-silk")) return { type: "collection", label: "the Pure Silk collection", category: "cami" };
    if (path.includes("/collections/satin-deluxe")) return { type: "collection", label: "the Satin Deluxe collection" };
    if (path.includes("/collections/cotton-seamless")) return { type: "collection", label: "the Cotton Seamless collection" };
    if (path.includes("/collections/cotton-sensation")) return { type: "collection", label: "the Cotton Sensation collection" };
    if (path.includes("/collections/cotton-superior")) return { type: "collection", label: "the Cotton Superior collection" };
    if (path.includes("/collections/cotton-deluxe")) return { type: "collection", label: "the Cotton Deluxe collection" };
    if (path.includes("/collections/cotton-essentials")) return { type: "collection", label: "the Cotton Essentials collection" };
    if (path.includes("/collections/cotton-pure")) return { type: "collection", label: "the Cotton Pure collection" };
    if (path.includes("/collections/cotton-lace")) return { type: "collection", label: "the Cotton Lace collection" };
    if (path.includes("/collections/mercerised-cotton")) return { type: "collection", label: "the Cotton Sleepwear collection" };
    if (path.includes("/collections/moments")) return { type: "collection", label: "the Moments collection" };
    if (path.includes("/collections/ultralight")) return { type: "collection", label: "the Ultralight collection" };
    if (path.includes("/collections/night-day")) return { type: "collection", label: "the Night & Day collection" };
    if (path.includes("/collections/touch-feeling")) return { type: "collection", label: "the Touch Feeling collection" };
    if (path.includes("/collections/invisibile-cotton") || path.includes("/collections/invisible-cotton")) return { type: "collection", label: "the Invisible Cotton collection" };

    // Special edits
    if (path.includes("/collections/the-bridal-edit")) return { type: "collection", label: "the Bridal Edit", occasion: "bridal" };
    if (path.includes("/collections/hanro-gift-guide")) return { type: "collection", label: "the Gift Guide", occasion: "gift" };
    if (path.includes("/collections/accessories")) return { type: "collection", label: "accessories", category: "accessories" };
    if (path.includes("/collections/new-arrivals") || path.includes("/collections/womens-new-arrivals") || path.includes("/collections/mens-new-arrivals-1")) return { type: "collection", label: "new arrivals" };
    if (path.includes("/collections/sale") || path.includes("/collections/mens-sale") || path.includes("/collections/boxing-day-sale")) return { type: "collection", label: "sale" };
    if (path.includes("/collections/best-in-stock")) return { type: "collection", label: "best in stock" };
    if (path.includes("/collections/shop-all") || path.includes("/collections/ella")) return { type: "collection", label: "the full Hanro range" };

    // Generic men's / women's catch-alls (kept after specific matches)
    if (path.includes("/collections/womens-shop-all") || path.includes("/collections/womens-")) return { type: "collection", label: "the women's collection" };
    if (path.includes("/collections/mens-shop-all") || path.includes("/collections/mens-")) return { type: "collection", label: "the men's collection" };

    if (path.includes("/collections/")) return { type: "collection", label: "this collection" };
    if (path.includes("/products/")) return { type: "product", label: document.querySelector('h1')?.textContent?.trim() || "this piece" };
    if (path.includes("/cart")) return { type: "cart", label: "shopping bag" };
    if (path === "/" || path === "") return { type: "home", label: "homepage" };
    return { type: "page", label: title || "HANRO" };
  }

  // ── Conversation memory ──
  let conversationContext = {
    category: null,
    customerName: null,
    occasion: null,
    size: null,
    styleConcerns: [],
    fabricPreference: null,
    lengthPreference: null,
    colourPreference: null,
    lastQuery: null,
    lastProducts: null,
    decisionStep: null,
  };

  function resetConversationContext() {
    conversationContext = {
      category: null, customerName: null, occasion: null, size: null,
      styleConcerns: [], fabricPreference: null, lengthPreference: null,
      colourPreference: null, lastQuery: null, lastProducts: null, decisionStep: null,
    };
  }

  let conversationHistory = [];
  const MAX_HISTORY_TURNS = 10;

  function pushHistory(role, parts) {
    conversationHistory.push({ role: role, parts: parts });
    while (conversationHistory.length > MAX_HISTORY_TURNS * 2) {
      conversationHistory.shift();
    }
    saveSession();
  }

  function resetConversationHistory() {
    conversationHistory = [];
  }

  // ── Session persistence across page navigation ──
  // Using localStorage (content script runs in MAIN world, so chrome.storage is unavailable)
  const LEGACY_SESSION_KEY = 'giniaAiSession';
  const LEGACY_DISMISSED_KEY = 'giniaAiDismissed';
  const SESSION_KEY = scopedStorageKey('session');
  const DISMISSED_KEY = scopedStorageKey('dismissedAt');

  function saveSession() {
    try {
      const chatHTML = document.getElementById('bellAiBody')?.innerHTML || '';
      const session = {
        version: SESSION_VERSION,
        shopId: SHOP_ID,
        conversationSession: conversationSession,
        conversationSessionId: conversationSession.id,
        context: conversationContext,
        history: conversationHistory,
        chatHTML: chatHTML,
        panelOpen: document.getElementById('bellAiPanel')?.classList.contains('bell-ai-open') || false,
        lastInteractionAt: conversationSession.lastInteractionAt,
        savedAt: Date.now()
      };
      localStorage.setItem(SESSION_KEY, JSON.stringify(session));
      console.log("[HANRO AI] Session saved to localStorage");
    } catch (e) {
      console.log("[HANRO AI] Could not save session:", e);
    }
  }

  function restoreSession() {
    try {
      const raw = localStorage.getItem(SESSION_KEY) || localStorage.getItem(LEGACY_SESSION_KEY);
      if (!raw) return false;
      const session = JSON.parse(raw);
      if (session.version && session.version !== SESSION_VERSION) {
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(LEGACY_SESSION_KEY);
        rotateConversationSession("version_changed");
        return false;
      }
      const lastInteractionAt = Number(session.lastInteractionAt || session.savedAt || 0);
      // Only restore if the customer interacted within the last 30 minutes.
      if (!lastInteractionAt || Date.now() - lastInteractionAt > SESSION_TTL_MS) {
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(LEGACY_SESSION_KEY);
        rotateConversationSession("inactive_timeout");
        return false;
      }
      if (session.conversationSession?.id) {
        conversationSession = {
          ...createConversationSession("restored"),
          ...session.conversationSession,
          version: SESSION_VERSION,
          lastInteractionAt
        };
      } else if (session.conversationSessionId) {
        conversationSession = {
          ...createConversationSession("restored_legacy"),
          id: session.conversationSessionId,
          lastInteractionAt
        };
      }
      persistConversationSessionMetadata();
      // Restore conversation state
      if (session.context) {
        conversationContext = { ...conversationContext, ...session.context };
        if (!Array.isArray(conversationContext.styleConcerns)) conversationContext.styleConcerns = [];
      }
      if (Array.isArray(session.history)) conversationHistory = session.history;
      console.log("[HANRO AI] Session restored, history length:", conversationHistory.length);
      return session;
    } catch (e) {
      console.log("[HANRO AI] Could not restore session:", e);
      return false;
    }
  }

  function clearSavedSession() {
    try {
      localStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(LEGACY_SESSION_KEY);
    } catch (e) {}
  }

  function setPanelDismissed(value) {
    try {
      if (value) localStorage.setItem(DISMISSED_KEY, String(Date.now()));
      else {
        localStorage.removeItem(DISMISSED_KEY);
        localStorage.removeItem(LEGACY_DISMISSED_KEY);
      }
    } catch (e) {}
  }

  function wasPanelDismissed() {
    try {
      const raw = localStorage.getItem(DISMISSED_KEY) || localStorage.getItem(LEGACY_DISMISSED_KEY);
      if (!raw) return false;
      const dismissedAt = Number(raw) || 0;
      if (Date.now() - dismissedAt > DISMISSED_TTL_MS) {
        localStorage.removeItem(DISMISSED_KEY);
        localStorage.removeItem(LEGACY_DISMISSED_KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function buildSessionContextNote() {
    const ctx = conversationContext;
    if (!ctx.category && !ctx.occasion && !ctx.size && ctx.styleConcerns.length === 0) return "";

    const lines = ["", "## Current session — what we know about this customer"];
    if (ctx.customerName) lines.push("- Name: " + ctx.customerName);
    if (ctx.category) lines.push("- Category: " + ctx.category);
    if (ctx.occasion) lines.push("- Occasion: " + ctx.occasion);
    if (ctx.fabricPreference) lines.push("- Fabric preference: " + ctx.fabricPreference);
    if (ctx.size) lines.push("- Size: " + ctx.size);
    if (ctx.lengthPreference) lines.push("- Length preference: " + ctx.lengthPreference);
    if (ctx.colourPreference) lines.push("- Colour preference: " + ctx.colourPreference);
    if (ctx.styleConcerns.length > 0) lines.push("- Style concerns: " + ctx.styleConcerns.join(", "));
    if (ctx.lastQuery) lines.push("- Last search: \"" + ctx.lastQuery + "\"");

    const missing = [];
    if (!ctx.category) missing.push("category (bra/brief/nightdress/pyjama/robe/cami/men's underwear)");
    if (!ctx.occasion) missing.push("occasion (everyday/sleep/lounge/gift/travel)");
    if (ctx.category && ctx.occasion) {
      if (!ctx.fabricPreference) missing.push("fabric preference (cotton/pure-silk/woolen-silk/satin/modal/lace)");
      if (!ctx.size) missing.push("size (XS-XL)");
    }

    if (missing.length > 0) {
      lines.push("");
      lines.push("Still need to find out: " + missing.join(", "));
      lines.push("Ask about these ONE AT A TIME using askClarification.");
    } else {
      lines.push("");
      lines.push("We have enough info to make a recommendation! Use searchProducts or guidedRecommendation.");
    }

    return lines.join("\n");
  }

  // ── Conversational agent ──
  async function conversationalAgent(userText) {
    extractContextFromMessage(userText);
    pushHistory("user", [{ text: userText }]);

    try {
      const sessionNote = buildSessionContextNote();
      const response1 = await callGeminiWithTools(conversationHistory, sessionNote);
      const parts = response1?.candidates?.[0]?.content?.parts || [];

      let functionCall = null;
      let textReply = "";
      for (const part of parts) {
        if (part.functionCall) { functionCall = part.functionCall; break; }
        if (part.text) textReply = part.text;
      }

      if (functionCall) {
        pushHistory("model", [{ functionCall: functionCall }]);
        const toolResult = await executeTool(functionCall.name, functionCall.args || {});
        pushHistory("user", [{
          functionResponse: {
            name: functionCall.name,
            response: toolResult || { status: "ok" }
          }
        }]);
        return;
      }

      if (textReply) {
        pushHistory("model", [{ text: textReply }]);
        hideTyping();
        addBotBubble(textReply);
      } else {
        hideTyping();
        addBotBubble("Hmm, let me think about that. Could you tell me a bit more about what you’re looking for?");
      }
    } catch (e) {
      console.error("[HANRO AI] Conversational agent error:", e);
      hideTyping();
      addBotBubble("Oops, I got a bit tangled there. Could you try asking again? I’m here to help!");
    }
  }

  // ── Extract context clues from user messages ──
  function extractContextFromMessage(text) {
    const t = text.toLowerCase();

    // Category
    if (/\bbra(s|lette)?\b/.test(t)) conversationContext.category = "bra";
    if (/\bbrief(s)?\b|\bboyleg(s)?\b|\bthong(s)?\b|\bpanty|panties\b/.test(t)) conversationContext.category = "briefs";
    if (/\bboxer(s)?\b/.test(t)) conversationContext.category = "boxers";
    if (/nightdress|nightie|nightgown|night dress|sleep dress/.test(t)) conversationContext.category = "nightdress";
    if (/cami|camisole|spaghetti/.test(t)) conversationContext.category = "cami";
    if (/\brobe|kimono|dressing gown/.test(t)) conversationContext.category = "robe";
    if (/pyjama|pajama|\bpj\b|pjs/.test(t)) conversationContext.category = "pyjama";
    if (/\bshorts?\b/.test(t)) conversationContext.category = "shorts";
    if (/\bpants?\b|trouser|legging/.test(t)) conversationContext.category = "pants";
    if (/\bshirt(s)?\b/.test(t)) conversationContext.category = "shirt";
    if (/men'?s underwear|mens underwear|men.+brief|men.+boxer/.test(t)) conversationContext.category = "mens-underwear";
    if (/matching set|pyjama set|pj set|underwear set/.test(t)) conversationContext.category = "set";

    // Size
    if (/\b(xs|extra small|size 6|au 6)\b/.test(t)) conversationContext.size = "XS";
    else if (/\b(size 8|au 8|small\b)/.test(t)) conversationContext.size = "S";
    else if (/\b(size 10|au 10|medium\b)/.test(t)) conversationContext.size = "M";
    else if (/\b(size 12|au 12|\blarge\b)/.test(t)) conversationContext.size = "L";
    else if (/\b(xl|extra large|size 14|au 14)\b/.test(t)) conversationContext.size = "XL";

    // Occasion
    if (/bride|bridal|wedding|engagement|hen\b|bachelorette/.test(t)) conversationContext.occasion = "bridal";
    else if (/honeymoon/.test(t)) conversationContext.occasion = "honeymoon";
    else if (/gift|present|for (my|her|him)|mother's day|anniversary|birthday/.test(t)) conversationContext.occasion = "gift";
    else if (/travel|holiday|weekend away|trip|vacation/.test(t)) conversationContext.occasion = "travel";
    else if (/day\s?to\s?night|going out|dinner|event/.test(t)) conversationContext.occasion = "day-to-night";
    else if (/everyday|daily|basic/.test(t)) conversationContext.occasion = "everyday";

    // Style concerns
    if (/hot sleeper|night sweat|overheat|humid/.test(t)) {
      if (!conversationContext.styleConcerns.includes("hot-sleeper")) conversationContext.styleConcerns.push("hot-sleeper");
    }
    if (/cold sleeper|chilly|freeze|winter/.test(t)) {
      if (!conversationContext.styleConcerns.includes("cold-sleeper")) conversationContext.styleConcerns.push("cold-sleeper");
    }
    if (/sensitive skin|eczema|allergic|rash|itch/.test(t)) {
      if (!conversationContext.styleConcerns.includes("sensitive-skin")) conversationContext.styleConcerns.push("sensitive-skin");
    }

    // Fabric
    if (/woolen silk|wool silk|wool-silk/.test(t)) conversationContext.fabricPreference = "woolen-silk";
    else if (/pure silk|mulberry|100% silk|silk\b/.test(t)) conversationContext.fabricPreference = "pure-silk";
    if (/satin deluxe|\bsatin\b/.test(t)) conversationContext.fabricPreference = "satin-deluxe";
    if (/cotton seamless|seamless/.test(t)) conversationContext.fabricPreference = "cotton-seamless";
    else if (/cotton lace|cotton-lace/.test(t)) conversationContext.fabricPreference = "cotton-lace";
    else if (/cotton sensation|cotton superior|cotton deluxe|cotton pure|cotton essential|\bcotton\b/.test(t)) conversationContext.fabricPreference = "cotton-premium";
    if (/\blace\b/.test(t) && !conversationContext.fabricPreference) conversationContext.fabricPreference = "cotton-lace";
    if (/\bmodal\b/.test(t)) conversationContext.fabricPreference = "modal";
    if (/\bviscose\b/.test(t)) conversationContext.fabricPreference = "viscose";

    // Length
    if (/\bmini\b/.test(t)) conversationContext.lengthPreference = "mini";
    else if (/\bmidi\b/.test(t)) conversationContext.lengthPreference = "midi";
    else if (/\bmaxi\b|floor[- ]?length|long/.test(t)) conversationContext.lengthPreference = "maxi";

    // Name: "my name is X" / "I'm X"
    const nameMatch = t.match(/(?:my name is |i'm |i am |call me )(\w+)/);
    if (nameMatch) conversationContext.customerName = nameMatch[1].charAt(0).toUpperCase() + nameMatch[1].slice(1);
  }

  async function callGeminiWithTools(contents, sessionContextNote) {
    const body = {
      shopId: SHOP_ID,
      contents: contents,
      sessionContext: sessionContextNote || ""
    };
    const resp = await fetch(AI_BACKEND_ENDPOINT, {
      method: "POST",
      credentials: GINIA_AI_CONFIG.fetchCredentials || "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });
    if (!resp.ok) {
      const errText = await resp.text();
      console.error("[HANRO AI] Backend AI tools call error:", resp.status, errText);
      throw new Error("AI backend error " + resp.status);
    }
    return await resp.json();
  }

  // ── Execute a tool call from Gemini ──
  async function executeTool(name, args) {
    console.log("[HANRO AI] Tool call:", name, args);
    publishAnalyticsEvent("agent_tool_called", {
      toolName: name,
      decisionStep: args?.decisionStep || "",
      query: args?.query || args?.newQuery || "",
      styleConcern: args?.styleConcern || "",
      category: args?.category || ""
    });
    hideTyping();

    switch (name) {
      case "searchProducts": {
        const query = args.query || "";
        const lifeStage = args.lifeStage || "all";
        const size = args.size || "all";
        const intro = args.advisorIntro || "Here's what I'd recommend:";
        const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];

        if (lifeStage !== "all") conversationContext.lifeStage = lifeStage;
        if (size !== "all") conversationContext.size = size;
        conversationContext.lastQuery = query;

        await runProductSearch(query, intro, followUps);
        return { status: "ok", productsShown: true };
      }

      case "guidedRecommendation": {
        const concern = args.styleConcern || "everyday";
        const rec = args.recommendation || "Here are my top picks:";
        const products = Array.isArray(args.suggestedProducts) ? args.suggestedProducts : [];
        const flavour = args.suggestedFabric || "";
        const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];

        if (!conversationContext.styleConcerns.includes(concern)) {
          conversationContext.styleConcerns.push(concern);
        }

        let html = buildStyleCard(concern);
        html += `<div class="bell-ai-bubble" style="margin-top:8px">${rec}</div>`;

        if (products.length > 0) {
          html += '<div class="bell-ai-rec-list">';
          products.forEach(p => { html += `<div class="bell-ai-rec-item">✨ ${p}</div>`; });
          html += '</div>';
        }

        if (flavour) {
          html += `<div class="bell-ai-fabric-tip">💡 ${flavour}</div>`;
        }

        addBotBubble(html);

        // Search using the actual product names Gemini suggested, not just the concern keyword
        let allFoundProducts = [];
        if (products.length > 0) {
          // Search for each suggested product individually for best matches
          const searchPromises = products.map(name => searchSiteProducts(name));
          const results = await Promise.allSettled(searchPromises);
          const seen = new Set();
          results.forEach(r => {
            if (r.status === 'fulfilled' && r.value) {
              r.value.forEach(p => {
                if (!seen.has(p.id)) { seen.add(p.id); allFoundProducts.push(p); }
              });
            }
          });
        }
        // Fallback: also search by concern + life stage if we didn't find enough
        if (allFoundProducts.length < 2) {
          const fallbackQuery = concern + " " + (conversationContext.category || "") + " " + (conversationContext.fabricPreference || "");
          const fallbackProducts = await searchSiteProducts(fallbackQuery.trim());
          const seen = new Set(allFoundProducts.map(p => p.id));
          fallbackProducts.forEach(p => {
            if (!seen.has(p.id)) { seen.add(p.id); allFoundProducts.push(p); }
          });
        }
        allFoundProducts = await enrichWithImages(allFoundProducts);
        const displayProducts = allFoundProducts.slice(0, 6);
        if (displayProducts.length > 0) {
          analyticsState.productsShown += displayProducts.length;
          publishAnalyticsEvent("products_shown", {
            source: "guided_recommendation",
            concern,
            displayedCount: displayProducts.length,
            products: displayProducts.map(p => ({ id: p.id || "", name: p.name || "", price: p.price || "" }))
          });
          let resultsHTML = '<div class="bell-ai-products-grid">';
          displayProducts.forEach(p => { resultsHTML += productCardHTML(p); });
          resultsHTML += '</div>';
          const resultsBubble = addBotBubble(resultsHTML, false);

          if (followUps.length > 0) {
            addActions(followUps.map(q => ({ label: q, msg: q })), false);
          }
          setTimeout(() => { resultsBubble.scrollIntoView({ behavior: "smooth", block: "start" }); }, 50);
        } else if (followUps.length > 0) {
          addActions(followUps.map(q => ({ label: q, msg: q })));
        }

        return { status: "ok" };
      }

      case "askClarification": {
        const question = args.question || "Tell me a bit more about your pet?";
        const chipSuggestions = Array.isArray(args.suggestions) ? args.suggestions : [];
        const step = args.decisionStep || "other";

        conversationContext.decisionStep = step;
        addBotBubble(question);

        if (chipSuggestions.length > 0) {
          addActions(chipSuggestions.map(s => ({ label: s, msg: s })));
        }
        return { status: "ok" };
      }

      case "answerQuestion": {
        const answer = args.answer || "Great question!";
        const chips = Array.isArray(args.followUpChips) ? args.followUpChips : [];
        addBotBubble(answer);
        if (chips.length > 0) {
          addActions(chips.map(c => ({ label: c, msg: c })));
        }
        return { status: "ok" };
      }

      case "fabricGuide": {
        const intro = args.intro || "Hanro works with six core fabric families:";
        addBotBubble(intro);
        addBotBubble(buildFabricGuideHTML(
          args.pureSilkNote || args.silkNote || "Pure Silk is smooth, fluid and temperature-aware — refined sleepwear and day-to-night layers.",
          args.woolenSilkNote || "Woolen Silk is a wool-silk blend that's quietly warm and skin-soft — ideal for winter layering.",
          args.satinNote || "Satin Deluxe — smooth lustrous finish with a sculpting fit, beautifully gift-worthy.",
          args.cottonPremiumNote || args.cottonNote || "Cotton Sensation, Superior and Deluxe are Hanro's mercerised cotton lines — breathable, refined, long-wearing.",
          args.cottonSeamlessNote || "Cotton Seamless wears invisibly under tailoring — soft no-edge construction.",
          args.modalNote || args.bambooNote || "Modal — silky-soft drape with natural moisture-wicking. Great for hot sleepers and sensitive skin."
        ));

        if (args.recommendation) {
          addBotBubble(`💡 ${args.recommendation}`);
        }

        const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : ["Show cotton basics", "Show Pure Silk", "Show pyjamas", "Show robes"];
        addActions(followUps.map(q => ({ label: q, msg: q })));
        return { status: "ok" };
      }

      case "bundleRecommendation": {
        const rec = args.recommendation || "Here’s a matching pairing worth considering:";
        const bundleName = args.setName || args.bundleName || "";
        addBotBubble("✨ " + rec);

        let bundleProducts = await searchSiteProducts("set matching " + bundleName);
        bundleProducts = await enrichWithImages(bundleProducts);
        const displayBundles = bundleProducts.slice(0, 4);
        if (displayBundles.length > 0) {
          analyticsState.productsShown += displayBundles.length;
          publishAnalyticsEvent("products_shown", {
            source: "bundle_recommendation",
            displayedCount: displayBundles.length,
            products: displayBundles.map(p => ({ id: p.id || "", name: p.name || "", price: p.price || "" }))
          });
          let resultsHTML = '<div class="bell-ai-products-grid">';
          displayBundles.forEach(p => { resultsHTML += productCardHTML(p); });
          resultsHTML += '</div>';
          const resultsBubble = addBotBubble(resultsHTML, false);

          const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];
          if (followUps.length > 0) {
            addActions(followUps.map(q => ({ label: q, msg: q })), false);
          }
          setTimeout(() => { resultsBubble.scrollIntoView({ behavior: "smooth", block: "start" }); }, 50);
        } else {
          const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];
          if (followUps.length > 0) {
            addActions(followUps.map(q => ({ label: q, msg: q })));
          }
        }
        return { status: "ok" };
      }

      case "bridalRecommendation": {
        const rec = args.recommendation || "For a polished gift or special occasion, I would start with refined pyjamas, a robe, or a premium everyday basic in their preferred fabric.";
        conversationContext.occasion = "bridal";
        addBotBubble("💍 " + rec);

        let bridalProducts = await searchSiteProducts("gift robe pyjama nightdress premium basics");
        bridalProducts = await enrichWithImages(bridalProducts);
        const displayCat = bridalProducts.slice(0, 4);
        if (displayCat.length > 0) {
          analyticsState.productsShown += displayCat.length;
          publishAnalyticsEvent("products_shown", {
            source: "bridal_recommendation",
            displayedCount: displayCat.length,
            products: displayCat.map(p => ({ id: p.id || "", name: p.name || "", price: p.price || "" }))
          });
          let resultsHTML = '<div class="bell-ai-products-grid">';
          displayCat.forEach(p => { resultsHTML += productCardHTML(p); });
          resultsHTML += '</div>';
          const resultsBubble = addBotBubble(resultsHTML, false);

          const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];
          if (followUps.length > 0) {
            addActions(followUps.map(q => ({ label: q, msg: q })), false);
          }
          setTimeout(() => { resultsBubble.scrollIntoView({ behavior: "smooth", block: "start" }); }, 50);
        } else {
          const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];
          if (followUps.length > 0) {
            addActions(followUps.map(q => ({ label: q, msg: q })));
          }
        }
        return { status: "ok" };
      }

      case "refineRecommendation": {
        const newQuery = args.newQuery || conversationContext.lastQuery || "";
        const ack = args.acknowledgement || "Let me find something different:";
        const followUps = Array.isArray(args.followUpQuestions) ? args.followUpQuestions : [];

        addBotBubble(`<em style="color:#666">${ack}</em>`);
        conversationContext.lastQuery = newQuery;
        await runProductSearch(newQuery, "", followUps);
        return { status: "ok", refinedTo: newQuery };
      }

      default:
        console.warn("[HANRO AI] Unknown tool:", name);
        addBotBubble("I’m not sure about that one yet — but I’d love to help you find the right HANRO piece.");
        return { status: "unknown_tool" };
    }
  }

  // ── Product search with results display ──
  async function runProductSearch(query, advisorIntro, followUpQuestions) {
    if (suggestions) suggestions.style.display = "none";

    const stepsText = ["Browsing the HANRO catalog...", "Curating the right pieces for you..."];
    let stepsHTML = '<div class="bell-ai-analysis">';
    stepsText.forEach((s, i) => { stepsHTML += `<div class="bell-ai-analysis-step bell-ai-pending" data-step="${i}">${ICONS.circle}<span>${s}</span></div>`; });
    stepsHTML += "</div>";
    const analysisBubble = addBotBubble(stepsHTML);

    const searchPromise = searchSiteProducts(query);
    await animateSteps(stepsText, analysisBubble, { keepLastActive: true });

    let products = [];
    try {
      products = await searchPromise;
      // Enrich products with images if missing
      products = await enrichWithImages(products);
    } catch (e) {
      console.error("[HANRO AI] Product search error:", e);
    }

    if (products.length === 0) {
      completeActiveAnalysisStep(analysisBubble);
      addBotBubble("Hmm, I couldn't find an exact match. Let me narrow it down — what kind of HANRO piece are you after?");
      addActions([
        { label: "Nightdresses", msg: "Show me women nightdresses" },
        { label: "Robes", msg: "Show me robes" },
        { label: "Pyjamas", msg: "Show me pyjama sets" },
        { label: "Men's basics", msg: "Show me men basics" },
      ]);
      return;
    }

    const displayProducts = products.slice(0, 6);
    analyticsState.productsShown += displayProducts.length;
    publishAnalyticsEvent("products_shown", {
      query,
      resultCount: products.length,
      displayedCount: displayProducts.length,
      products: displayProducts.map(p => ({
        id: p.id || "",
        handle: p.url?.split('/products/')?.[1]?.split('?')?.[0] || p.id || "",
        name: p.name || "",
        price: p.price || ""
      }))
    });
    let resultsHTML = "";
    if (advisorIntro) resultsHTML += `<div class="bell-ai-advisor-intro">${advisorIntro}</div>`;
    resultsHTML += '<div class="bell-ai-products-grid">';
    displayProducts.forEach(p => { resultsHTML += productCardHTML(p); });
    resultsHTML += "</div>";
    const resultsBubble = addBotBubble(resultsHTML, false);
    completeActiveAnalysisStep(analysisBubble);

    const chips = (Array.isArray(followUpQuestions) && followUpQuestions.length > 0)
      ? followUpQuestions.slice(0, 4)
      : ["Show me matching sets", "Different fabric?", "Best sellers", "Care & sizing info"];

    addBotBubble("What do you think? Want me to narrow it down further?", false);
    addActions(chips.map(q => ({ label: q, msg: q })), false);

    // Scroll to top of results after DOM settles
    setTimeout(() => { resultsBubble.scrollIntoView({ behavior: "smooth", block: "start" }); }, 50);
  }

  // ── Step animation ──
  async function animateSteps(stepsText, container, options = {}) {
    for (let i = 0; i < stepsText.length; i++) {
      const stepEls = container.querySelectorAll(".bell-ai-analysis-step");
      if (stepEls[i]) {
        stepEls[i].classList.remove("bell-ai-pending");
        stepEls[i].classList.add("bell-ai-active");
        stepEls[i].querySelector("svg").outerHTML = ICONS.spinner;
      }
      await sleep(800);
      if (options.keepLastActive && i === stepsText.length - 1) return;
      if (stepEls[i]) {
        stepEls[i].classList.remove("bell-ai-active");
        stepEls[i].classList.add("bell-ai-done");
        stepEls[i].querySelector("svg").outerHTML = ICONS.check;
      }
    }
  }

  function completeActiveAnalysisStep(container) {
    const activeStep = container && container.querySelector(".bell-ai-analysis-step.bell-ai-active");
    if (!activeStep) return;
    activeStep.classList.remove("bell-ai-active");
    activeStep.classList.add("bell-ai-done");
    const icon = activeStep.querySelector("svg");
    if (icon) icon.outerHTML = ICONS.check;
  }

  // ── UI Helpers ──
  function addBotBubble(html, autoScroll = true) {
    const wrapper = document.createElement("div");
    wrapper.className = "bell-ai-msg bell-ai-msg-bot";
    wrapper.innerHTML = `<div class="bell-ai-bubble">${html}</div><div class="bell-ai-msg-time">${timeStr()}</div>`;
    body.insertBefore(wrapper, typing.closest(".bell-ai-msg"));
    refreshLiveProductPrices(wrapper);
    if (autoScroll) body.scrollTop = body.scrollHeight;
    markConversationActivity();
    saveSession();
    return wrapper;
  }

  function addUserBubble(text) {
    const wrapper = document.createElement("div");
    wrapper.className = "bell-ai-msg bell-ai-msg-user";
    wrapper.innerHTML = `<div class="bell-ai-bubble">${text}</div><div class="bell-ai-msg-time">${timeStr()}</div>`;
    body.insertBefore(wrapper, typing.closest(".bell-ai-msg"));
    body.scrollTop = body.scrollHeight;
    markConversationActivity();
    saveSession();
  }

  function addActions(actions, autoScroll = true) {
    const wrapper = document.createElement("div");
    wrapper.className = "bell-ai-msg bell-ai-msg-bot";
    let btns = '<div class="bell-ai-actions">';
    actions.forEach(a => {
      btns += `<button class="bell-ai-action-btn" data-search="${(a.msg || a.label).replace(/"/g, '&quot;')}">${a.label}</button>`;
    });
    btns += '</div>';
    wrapper.innerHTML = btns;
    body.insertBefore(wrapper, typing.closest(".bell-ai-msg"));
    if (autoScroll) body.scrollTop = body.scrollHeight;
    markConversationActivity();
    saveSession();
  }

  function showTyping() { typing.classList.add("bell-ai-visible"); body.scrollTop = body.scrollHeight; }
  function hideTyping() { typing.classList.remove("bell-ai-visible"); }

  // ── Build panel DOM ──
  const t = timeStr();
  const pageCtx = getPageContext();
  const contextNote = pageCtx.category
    ? `I see you're browsing our ${pageCtx.label} — I can help you find the perfect piece!`
    : pageCtx.occasion === "bridal"
    ? "I can help you find a polished HANRO piece for the occasion."
    : "Tell me a little about what you're looking for and I'll help you find the right HANRO piece.";

  const greeting = `Hi, I’m your HANRO product advisor. Whether you’re choosing women’s nightwear, men’s basics, refined underwear, robes, pyjamas or a gift, I’ll help you find the piece that feels just right.`;

  const root = document.createElement("div");
  root.id = "ginia-ai-root";
  root.innerHTML =
    '<div class="bell-ai-overlay" id="bellAiOverlay"></div>' +
    '<button class="bell-ai-trigger" id="bellAiTrigger" aria-label="Ask the stylist">' +
      '<span class="bell-ai-trigger-icon"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6L12 2zm7 10l.9 3.1L23 16l-3.1.9L19 20l-.9-3.1L15 16l3.1-.9L19 12zM5 14l.7 2.3L8 17l-2.3.7L5 20l-.7-2.3L2 17l2.3-.7L5 14z"/></svg></span>' +
      '<span class="bell-ai-trigger-label">Ask the Stylist</span>' +
      '<span class="bell-ai-trigger-badge">1</span>' +
    '</button>' +
    '<div class="bell-ai-panel" id="bellAiPanel">' +
      '<div class="bell-ai-header">' +
        '<div class="bell-ai-header-left">' +
          '<div class="bell-ai-avatar">H</div>' +
          '<div><div class="bell-ai-title">HANRO Stylist</div><div class="bell-ai-subtitle"><span class="bell-ai-status-dot"></span>Product Advisor • Online</div></div>' +
        '</div>' +
        '<div class="bell-ai-header-right">' +
          '<button class="bell-ai-new-chat" id="bellAiNewChat" title="Start a fresh conversation">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7L21 8"/><polyline points="21 3 21 8 16 8"/></svg>' +
            '<span class="bell-ai-new-chat-label">New Chat</span>' +
          '</button>' +
          '<a href="/cart" class="bell-ai-cart-icon" id="bellAiCartIcon" title="View bag">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>' +
            '<span class="bell-ai-cart-badge" id="bellAiCartBadge">0</span>' +
          '</a>' +
          '<button class="bell-ai-close" id="bellAiClose">&times;</button>' +
        '</div>' +
      '</div>' +
      '<div class="bell-ai-body" id="bellAiBody">' +
        `<div class="bell-ai-context"><span class="bell-ai-context-icon">✨</span><span>${contextNote}</span></div>` +
        `<div class="bell-ai-msg bell-ai-msg-bot"><div class="bell-ai-bubble">${greeting}</div><div class="bell-ai-msg-time">${t}</div></div>` +
        '<div class="bell-ai-suggestions" id="bellAiSuggestions">' +
          '<button class="bell-ai-chip" data-search="Show me women nightdresses">Nightdresses</button>' +
          '<button class="bell-ai-chip" data-search="Show me women bras">Bras</button>' +
          '<button class="bell-ai-chip" data-search="Show me men basics">Men\'s basics</button>' +
          '<button class="bell-ai-chip" data-search="Show me pyjama sets">Pyjamas</button>' +
          '<button class="bell-ai-chip" data-search="Show me robes">Robes</button>' +
          '<button class="bell-ai-chip" data-search="What fabrics do you have">Fabric guide</button>' +
          '<button class="bell-ai-chip" data-search="I need a gift">Gift ideas</button>' +
        '</div>' +
        '<div class="bell-ai-msg bell-ai-msg-bot"><div class="bell-ai-typing" id="bellAiTyping"><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span></div></div>' +
      '</div>' +
      '<div class="bell-ai-input-area">' +
        '<input type="text" class="bell-ai-input" id="bellAiInput" placeholder="Tell me what you\'re after..." autocomplete="off">' +
        '<button class="bell-ai-send" id="bellAiSend"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button>' +
      '</div>' +
      '<div class="bell-ai-footer"><strong>Powered by WeAccelerate AI | Agentic Shopping Stylist</strong></div>' +
    '</div>';

  document.body.appendChild(root);

  // ── References ──
  const panel = qs("#bellAiPanel"), overlay = qs("#bellAiOverlay"), trigger = qs("#bellAiTrigger");
  const closeBtn = qs("#bellAiClose"), body = qs("#bellAiBody"), input = qs("#bellAiInput");
  const sendBtn = qs("#bellAiSend"), suggestions = qs("#bellAiSuggestions");
  const newChatBtn = qs("#bellAiNewChat");
  const cartIcon = qs("#bellAiCartIcon");
  let typing = qs("#bellAiTyping");

  function shouldAutofocusInput() {
    return !window.matchMedia || !window.matchMedia("(max-width: 720px), (pointer: coarse)").matches;
  }

  // Initial chat HTML — used when starting a fresh chat via the New Chat button.
  const initialChatHTML =
    `<div class="bell-ai-context"><span class="bell-ai-context-icon">✨</span><span>${contextNote}</span></div>` +
    `<div class="bell-ai-msg bell-ai-msg-bot"><div class="bell-ai-bubble">${greeting}</div><div class="bell-ai-msg-time">${t}</div></div>` +
    '<div class="bell-ai-suggestions" id="bellAiSuggestions">' +
          '<button class="bell-ai-chip" data-search="Show me women bras">Bras</button>' +
          '<button class="bell-ai-chip" data-search="Show me cotton briefs">Briefs</button>' +
          '<button class="bell-ai-chip" data-search="Show me women nightdresses">Nightdresses</button>' +
          '<button class="bell-ai-chip" data-search="Show me pyjama sets">Pyjamas</button>' +
          '<button class="bell-ai-chip" data-search="Show me robes">Robes</button>' +
          '<button class="bell-ai-chip" data-search="Show me men cotton basics">Men\'s basics</button>' +
          '<button class="bell-ai-chip" data-search="What\'s on sale">What\'s on sale</button>' +
          '<button class="bell-ai-chip" data-search="What fabrics do you have">Fabric guide</button>' +
    '</div>' +
    '<div class="bell-ai-msg bell-ai-msg-bot"><div class="bell-ai-typing" id="bellAiTyping"><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span></div></div>';

  function resetChatBodyToInitial() {
    body.innerHTML = initialChatHTML;
    typing = body.querySelector('#bellAiTyping') || body.querySelector('.bell-ai-typing');
    body.scrollTop = 0;
  }

  function consumePendingConversationUiReset() {
    if (!pendingConversationUiResetReason) return;
    resetChatBodyToInitial();
    publishAnalyticsEvent("conversation_expired", {
      reason: pendingConversationUiResetReason
    });
    pendingConversationUiResetReason = "";
    saveSession();
  }

  function startNewChat() {
    const previousConversationSessionId = conversationSession.id;
    const previousActivePanelMs = getActivePanelMs();
    const previousMessagesSent = analyticsState.messagesSent;
    rotateConversationSession("new_chat");
    resetAnalyticsCountersForConversation();
    publishAnalyticsEvent("new_chat_started", {
      previousConversationSessionId,
      previousActivePanelMs,
      previousMessagesSent
    });
    // Clear conversation state
    resetConversationContext();
    resetConversationHistory();
    clearSavedSession();
    try { sessionStorage.removeItem(CART_ATTRIBUTED_KEY); } catch (e) {}
    setPanelDismissed(false);
    // Reset chat body back to the greeting + suggestions + typing
    resetChatBodyToInitial();
    saveSession();
    if (input && shouldAutofocusInput()) input.focus();
  }

  let isOpen = false;

  function openPanel() {
    setPanelDismissed(false);
    markConversationActivity();
    consumePendingConversationUiReset();
    panel.classList.add("bell-ai-open");
    overlay.classList.add("bell-ai-active");
    trigger.style.display = "none";
    isOpen = true;
    if (!analyticsState.panelOpenedAt) analyticsState.panelOpenedAt = Date.now();
    markCartAttributed("agent_opened");
    publishAnalyticsEvent("panel_opened");
    if (input && shouldAutofocusInput()) input.focus();
    sendRuntimeMessage({ action: "panelOpened" });
  }

  function closePanel() {
    const openedAt = analyticsState.panelOpenedAt;
    const openDurationMs = openedAt ? Date.now() - openedAt : 0;
    if (openedAt) analyticsState.activePanelMs += openDurationMs;
    analyticsState.panelOpenedAt = 0;
    panel.classList.remove("bell-ai-open");
    overlay.classList.remove("bell-ai-active");
    trigger.style.display = "flex";
    isOpen = false;
    setPanelDismissed(true);
    saveSession();
    publishAnalyticsEvent("panel_closed", { openDurationMs });
    sendRuntimeMessage({ action: "panelClosed" });
  }

  trigger.addEventListener("click", openPanel);
  closeBtn.addEventListener("click", closePanel);
  overlay.addEventListener("click", closePanel);
  if (newChatBtn) newChatBtn.addEventListener("click", startNewChat);
  if (cartIcon) {
    cartIcon.addEventListener("click", () => {
      markConversationActivity();
      publishAnalyticsEvent("cart_icon_clicked");
      markCartAttributed("agent_cart_clicked");
      try { saveSession(); } catch (e) {}
    });
  }

  async function handleMessage(text) {
    if (!text.trim()) return;
    markConversationActivity();
    consumePendingConversationUiReset();
    analyticsState.messagesSent += 1;
    markCartAttributed("agent_message");
    publishAnalyticsEvent("message_sent", summarizeMessageForAnalytics(text));
    addUserBubble(text);
    input.value = "";
    showTyping();
    await conversationalAgent(text);
  }

  sendBtn.addEventListener("click", () => handleMessage(input.value));
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); handleMessage(input.value); }
  });

  body.addEventListener("click", (e) => {
    const actionBtn = e.target.closest(".bell-ai-action-btn");
    if (actionBtn) {
      const msg = actionBtn.dataset.search || actionBtn.textContent;
      publishAnalyticsEvent("quick_action_clicked", {
        label: actionBtn.textContent || "",
        message: msg
      });
      handleMessage(msg);
      return;
    }

    const chip = e.target.closest(".bell-ai-chip");
    if (chip) {
      const msg = chip.dataset.search || chip.textContent;
      publishAnalyticsEvent("suggestion_clicked", {
        label: chip.textContent || "",
        message: msg
      });
      handleMessage(msg);
      return;
    }

    // Add to Cart button
    const cartBtn = e.target.closest(".bell-ai-cart-btn");
    if (cartBtn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = cartBtn.dataset.handle;
      const name = cartBtn.dataset.productName;
      if (handle) showVariantSelector(handle, name, cartBtn);
      return;
    }

    // Color chip in size picker — swap active color + re-render sizes
    const colorChip = e.target.closest(".bell-ai-color-chip");
    if (colorChip && !colorChip.classList.contains("bell-ai-color-chip-unavailable")) {
      e.preventDefault();
      e.stopPropagation();
      const newColor = colorChip.dataset.color;
      const picker = colorChip.closest(".bell-ai-size-picker");
      if (picker && newColor) {
        // Fire-and-forget — activatePickerColor is async because sibling
        // color variants may need their JSON fetched on demand.
        activatePickerColor(picker, newColor, colorChip);
      }
      return;
    }

    // Size chip in size picker — actually add to cart for that variant
    const sizeChip = e.target.closest(".bell-ai-size-chip");
    if (sizeChip && !sizeChip.classList.contains("bell-ai-size-chip-unavailable") && !sizeChip.disabled) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = sizeChip.dataset.variantId;
      const handle = sizeChip.dataset.handle;
      const name = sizeChip.dataset.productName;
      publishAnalyticsEvent("variant_size_selected", getProductAnalyticsData(handle, name, {
        variantId,
        size: sizeChip.textContent || ""
      }));
      if (variantId) attemptAdd(sizeChip, variantId, handle, name);
      return;
    }

    // Size picker close (×) button
    const pickerClose = e.target.closest(".bell-ai-size-picker-close");
    if (pickerClose) {
      e.preventDefault();
      e.stopPropagation();
      const picker = pickerClose.closest(".bell-ai-size-picker");
      const grid = picker?.closest(".bell-ai-products-grid");
      const selected = grid?.querySelector(".bell-ai-product-selected");
      if (selected) dismissSizePicker(selected);
      else if (picker) picker.remove();
      return;
    }

    // Product link click — save session then navigate in same tab
    const productLink = e.target.closest("a[href*='/products/']");
    if (productLink) {
      e.preventDefault();
      e.stopPropagation();
      const href = productLink.getAttribute('href');
      if (href) {
        markConversationActivity();
        const card = productLink.closest(".bell-ai-product");
        publishAnalyticsEvent("product_clicked", {
          href,
          productHandle: card?.dataset.handle || href.split('/products/')[1]?.split('?')[0] || "",
          productId: card?.dataset.productId || "",
          productName: card?.querySelector(".bell-ai-product-name")?.textContent || ""
        });
        // Save session before navigating so chat survives page change
        saveSession();
        window.location.href = href;
      }
      return;
    }
  });

  addRuntimeMessageListener((message) => {
    if (message.action === "openPanel" || message.action === "togglePanel") {
      if (isOpen) closePanel(); else openPanel();
    }
  });

  // ── Load initial cart count ──
  publishAnalyticsEvent("loaded", {
    autoOpen: AUTO_OPEN,
    pageContext: getPageContext()
  });
  updateCartCount();

  // ── Restore session or auto-open ──
  try {
    const session = restoreSession();
    if (session && session.chatHTML) {
      // Restore chat messages from saved HTML
      body.innerHTML = session.chatHTML;
      // Re-acquire typing indicator reference (it's inside the restored HTML)
      typing = body.querySelector('.bell-ai-typing') || body.querySelector('#bellAiTyping');
      if (!typing) {
        // Re-add the typing indicator at the end
        const typingWrapper = document.createElement('div');
        typingWrapper.className = 'bell-ai-msg bell-ai-msg-bot';
        typingWrapper.innerHTML = '<div class="bell-ai-typing" id="bellAiTyping"><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span><span class="bell-ai-typing-dot"></span></div>';
        body.appendChild(typingWrapper);
        typing = typingWrapper.querySelector('.bell-ai-typing');
      }
      // Open panel if it was open before
      if (session.panelOpen && !wasPanelDismissed()) {
        openPanel();
      }
      console.log("[HANRO AI] Session restored from previous page");
      refreshLiveProductPrices(body);
      // Scroll to bottom
      body.scrollTop = body.scrollHeight;
      saveSession();
      try { localStorage.removeItem(LEGACY_SESSION_KEY); } catch (e) {}
    } else {
      // No saved session — auto-open on first visit if enabled.
      if (AUTO_OPEN && !wasPanelDismissed()) setTimeout(openPanel, 1500);
    }
  } catch(e) {
    if (AUTO_OPEN && !wasPanelDismissed()) setTimeout(openPanel, 2000);
  }

  // Auto-save session periodically (every 10 seconds when panel is open)
  setInterval(() => {
    if (document.getElementById('bellAiPanel')?.classList.contains('bell-ai-open')) {
      saveSession();
    }
  }, 10000);

  function sendAnalyticsSummary() {
    publishAnalyticsEvent("session_summary", {
      activePanelMs: getActivePanelMs(),
      pageSessionMs: Date.now() - analyticsState.pageStartedAt,
      panelOpen: isOpen,
      messagesSent: analyticsState.messagesSent,
      productsShown: analyticsState.productsShown,
      addToCartClicks: analyticsState.addToCartClicks,
      addToCartSuccesses: analyticsState.addToCartSuccesses,
      lastEventAt: analyticsState.lastEventAt
    }, { beacon: true });
  }

  window.addEventListener("pagehide", sendAnalyticsSummary);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sendAnalyticsSummary();
  });

  console.log("[HANRO AI] Product Advisor loaded for", SITE_BASE);
})();
